// Auto-generated resource for Ui — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const UiKeys = {
  Nav: {
    Playground: 'Ui.Nav.Playground',
    Mastery: 'Ui.Nav.Mastery',
    Account: 'Ui.Nav.Account',
    Instrument: 'Ui.Nav.Instrument',
    BodyLanguage: 'Ui.Nav.BodyLanguage',
    Archetype: 'Ui.Nav.Archetype',
    Riff: 'Ui.Nav.Riff',
    Storytelling: 'Ui.Nav.Storytelling',
    RecordReview: 'Ui.Nav.RecordReview',
    ActiveListening: 'Ui.Nav.ActiveListening',
    Progress: 'Ui.Nav.Progress',
    Library: 'Ui.Nav.Library',
    MasteryLockTooltip: 'Ui.Nav.MasteryLockTooltip',
    PremiumLockTooltip: 'Ui.Nav.PremiumLockTooltip',
    OpenNav: 'Ui.Nav.OpenNav',
    CloseNav: 'Ui.Nav.CloseNav',
    PracticeNavAria: 'Ui.Nav.PracticeNavAria',
    Wordmark: 'Ui.Nav.Wordmark',
  },
  Toast: {
    RegionAria: 'Ui.Toast.RegionAria',
    DismissAria: 'Ui.Toast.DismissAria',
    LiveUpdatesPaused: 'Ui.Toast.LiveUpdatesPaused',
    LiveUpdatesBack: 'Ui.Toast.LiveUpdatesBack',
  },
  Account: {
    MenuAria: 'Ui.Account.MenuAria',
    BalancesAria: 'Ui.Account.BalancesAria',
    Greeting: 'Ui.Account.Greeting',
    AiCredits: 'Ui.Account.AiCredits',
    SpendableBreakdown: 'Ui.Account.SpendableBreakdown',
    PracticesLeftToday: 'Ui.Account.PracticesLeftToday',
    PracticesLeftOne: 'Ui.Account.PracticesLeftOne',
    PracticesLeftMany: 'Ui.Account.PracticesLeftMany',
    PracticesLeftDetail: 'Ui.Account.PracticesLeftDetail',
    DailyPracticesLeftAria: 'Ui.Account.DailyPracticesLeftAria',
    Reviews: 'Ui.Account.Reviews',
    Profile: 'Ui.Account.Profile',
    Subscription: 'Ui.Account.Subscription',
    AdminConsole: 'Ui.Account.AdminConsole',
    SignOut: 'Ui.Account.SignOut',
    SignIn: 'Ui.Account.SignIn',
    BadgeGuest: 'Ui.Account.BadgeGuest',
    BadgePremium: 'Ui.Account.BadgePremium',
    BadgeAdmin: 'Ui.Account.BadgeAdmin',
    Preferences: 'Ui.Account.Preferences',
    Language: 'Ui.Account.Language',
    Theme: 'Ui.Account.Theme',
    Version: 'Ui.Account.Version',
  },
  PracticeLabel: {
    TheInstrument: 'Ui.PracticeLabel.TheInstrument',
    ArchetypePlay: 'Ui.PracticeLabel.ArchetypePlay',
    BodyLanguagePlay: 'Ui.PracticeLabel.BodyLanguagePlay',
    Storytelling: 'Ui.PracticeLabel.Storytelling',
    RecordAndReview: 'Ui.PracticeLabel.RecordAndReview',
    ActiveListening: 'Ui.PracticeLabel.ActiveListening',
    Riff: 'Ui.PracticeLabel.Riff',
    Standalone: 'Ui.PracticeLabel.Standalone',
  },
  Focus: {
    SessionTitle: 'Ui.Focus.SessionTitle',
    ExitConfirmTitle: 'Ui.Focus.ExitConfirmTitle',
    ExitConfirmBodyCredit: 'Ui.Focus.ExitConfirmBodyCredit',
    ExitConfirmBodyQuota: 'Ui.Focus.ExitConfirmBodyQuota',
    ExitConfirmForfeitCredit: 'Ui.Focus.ExitConfirmForfeitCredit',
    ExitConfirmForfeitQuota: 'Ui.Focus.ExitConfirmForfeitQuota',
    ExitConfirmNo: 'Ui.Focus.ExitConfirmNo',
    Resume: 'Ui.Focus.Resume',
    Pause: 'Ui.Focus.Pause',
    KeyboardShortcut: 'Ui.Focus.KeyboardShortcut',
    PausedWhileAway: 'Ui.Focus.PausedWhileAway',
    StartLabel: 'Ui.Focus.StartLabel',
    TimeOfPlanned: 'Ui.Focus.TimeOfPlanned',
    EndSessionAria: 'Ui.Focus.EndSessionAria',
    ExitAria: 'Ui.Focus.ExitAria',
    CueHistoryAria: 'Ui.Focus.CueHistoryAria',
    EndConfirmTitle: 'Ui.Focus.EndConfirmTitle',
    EndConfirm: 'Ui.Focus.EndConfirm',
    EndCancel: 'Ui.Focus.EndCancel',
    FallbackTitle: 'Ui.Focus.FallbackTitle',
  },
  LearningStage: {
    UnconsciousIncompetence: 'Ui.LearningStage.UnconsciousIncompetence',
    ConsciousIncompetence: 'Ui.LearningStage.ConsciousIncompetence',
    ConsciousCompetence: 'Ui.LearningStage.ConsciousCompetence',
    UnconsciousCompetence: 'Ui.LearningStage.UnconsciousCompetence',
  },
  Footer: {
    LegalAria: 'Ui.Footer.LegalAria',
    Terms: 'Ui.Footer.Terms',
    Privacy: 'Ui.Footer.Privacy',
    Pricing: 'Ui.Footer.Pricing',
    About: 'Ui.Footer.About',
    Support: 'Ui.Footer.Support',
    Copyright: 'Ui.Footer.Copyright',
    ThirdParty: 'Ui.Footer.ThirdParty',
    SupportEmail: 'Ui.Footer.SupportEmail',
  },
  Culture: {
    ToggleAria: 'Ui.Culture.ToggleAria',
    English: 'Ui.Culture.English',
    Vietnamese: 'Ui.Culture.Vietnamese',
    EnglishShort: 'Ui.Culture.EnglishShort',
    VietnameseShort: 'Ui.Culture.VietnameseShort',
  },
  Layout: {
    AboutLabel: 'Ui.Layout.AboutLabel',
    Offline: 'Ui.Layout.Offline',
  },
  NewVersion: {
    Title: 'Ui.NewVersion.Title',
    Body: 'Ui.NewVersion.Body',
    Refresh: 'Ui.NewVersion.Refresh',
    Later: 'Ui.NewVersion.Later',
  },
  Theme: {
    SwitchToLight: 'Ui.Theme.SwitchToLight',
    SwitchToDark: 'Ui.Theme.SwitchToDark',
    LightTheme: 'Ui.Theme.LightTheme',
    DarkTheme: 'Ui.Theme.DarkTheme',
  },
  SessionDetail: {
    SessionNotFound: 'Ui.SessionDetail.SessionNotFound',
    FailedToLoad: 'Ui.SessionDetail.FailedToLoad',
    BackAria: 'Ui.SessionDetail.BackAria',
    Back: 'Ui.SessionDetail.Back',
    Untitled: 'Ui.SessionDetail.Untitled',
    TabRecording: 'Ui.SessionDetail.TabRecording',
    TabDefault: 'Ui.SessionDetail.TabDefault',
  },
  BillingCancel: {
    Title: 'Ui.BillingCancel.Title',
    Heading: 'Ui.BillingCancel.Heading',
    Lede: 'Ui.BillingCancel.Lede',
    CheckoutFailed: 'Ui.BillingCancel.CheckoutFailed',
    Redirecting: 'Ui.BillingCancel.Redirecting',
    TryAgain: 'Ui.BillingCancel.TryAgain',
    KeepPractising: 'Ui.BillingCancel.KeepPractising',
    BackToPricing: 'Ui.BillingCancel.BackToPricing',
    BuyCredits: 'Ui.BillingCancel.BuyCredits',
  },
  BillingSuccess: {
    Title: 'Ui.BillingSuccess.Title',
    Finalising: 'Ui.BillingSuccess.Finalising',
    FinalisingBody: 'Ui.BillingSuccess.FinalisingBody',
    ReceiptSubscription: 'Ui.BillingSuccess.ReceiptSubscription',
    ReceiptSubscriptionBody: 'Ui.BillingSuccess.ReceiptSubscriptionBody',
    ReceiptPack: 'Ui.BillingSuccess.ReceiptPack',
    ReceiptPackBody: 'Ui.BillingSuccess.ReceiptPackBody',
    ReceiptTopUp: 'Ui.BillingSuccess.ReceiptTopUp',
    ReceiptTopUpBody: 'Ui.BillingSuccess.ReceiptTopUpBody',
    ReceiptGeneric: 'Ui.BillingSuccess.ReceiptGeneric',
    ReceiptGenericBody: 'Ui.BillingSuccess.ReceiptGenericBody',
    Updating: 'Ui.BillingSuccess.Updating',
    CheckBalance: 'Ui.BillingSuccess.CheckBalance',
    AiCredits: 'Ui.BillingSuccess.AiCredits',
    MonthlyCreditsLeft: 'Ui.BillingSuccess.MonthlyCreditsLeft',
    CloudStorage: 'Ui.BillingSuccess.CloudStorage',
    DailyPracticesLeft: 'Ui.BillingSuccess.DailyPracticesLeft',
    QuotaOf: 'Ui.BillingSuccess.QuotaOf',
    SavedUnder: 'Ui.BillingSuccess.SavedUnder',
    SavedNoEmail: 'Ui.BillingSuccess.SavedNoEmail',
    Recovery: 'Ui.BillingSuccess.Recovery',
    GoToBilling: 'Ui.BillingSuccess.GoToBilling',
    StartPractising: 'Ui.BillingSuccess.StartPractising',
    SaveAccountHeading: 'Ui.BillingSuccess.SaveAccountHeading',
    CollisionTitle: 'Ui.BillingSuccess.CollisionTitle',
    CollisionBody: 'Ui.BillingSuccess.CollisionBody',
    CollisionConfirm: 'Ui.BillingSuccess.CollisionConfirm',
    CollisionDeny: 'Ui.BillingSuccess.CollisionDeny',
    ConfirmEmailHeading: 'Ui.BillingSuccess.ConfirmEmailHeading',
    ConfirmEmailBody: 'Ui.BillingSuccess.ConfirmEmailBody',
    EmailLabel: 'Ui.BillingSuccess.EmailLabel',
    NameLabel: 'Ui.BillingSuccess.NameLabel',
    NameOptional: 'Ui.BillingSuccess.NameOptional',
    SendLink: 'Ui.BillingSuccess.SendLink',
    SendingLink: 'Ui.BillingSuccess.SendingLink',
    EmailRequired: 'Ui.BillingSuccess.EmailRequired',
    CheckEmailHeading: 'Ui.BillingSuccess.CheckEmailHeading',
    CheckEmailBody: 'Ui.BillingSuccess.CheckEmailBody',
    OtpLabel: 'Ui.BillingSuccess.OtpLabel',
    OtpEnterCode: 'Ui.BillingSuccess.OtpEnterCode',
    OtpInvalid: 'Ui.BillingSuccess.OtpInvalid',
    OtpExpired: 'Ui.BillingSuccess.OtpExpired',
    OtpTooManyAttempts: 'Ui.BillingSuccess.OtpTooManyAttempts',
    Verifying: 'Ui.BillingSuccess.Verifying',
    ResendLink: 'Ui.BillingSuccess.ResendLink',
    UseDifferentEmail: 'Ui.BillingSuccess.UseDifferentEmail',
    Cancel: 'Ui.BillingSuccess.Cancel',
    ClaimError: 'Ui.BillingSuccess.ClaimError',
  },
  CheckoutEmail: {
    Heading: 'Ui.CheckoutEmail.Heading',
    Body: 'Ui.CheckoutEmail.Body',
    EmailLabel: 'Ui.CheckoutEmail.EmailLabel',
    Continue: 'Ui.CheckoutEmail.Continue',
    Working: 'Ui.CheckoutEmail.Working',
    EmailRequired: 'Ui.CheckoutEmail.EmailRequired',
    EmailInvalid: 'Ui.CheckoutEmail.EmailInvalid',
    Cancel: 'Ui.CheckoutEmail.Cancel',
    Failed: 'Ui.CheckoutEmail.Failed',
    SignInHeading: 'Ui.CheckoutEmail.SignInHeading',
    SignInBody: 'Ui.CheckoutEmail.SignInBody',
    SignInCta: 'Ui.CheckoutEmail.SignInCta',
    SignInUseAnother: 'Ui.CheckoutEmail.SignInUseAnother',
  },
  Profile: {
    Title: 'Ui.Profile.Title',
    Heading: 'Ui.Profile.Heading',
    NameSectionAria: 'Ui.Profile.NameSectionAria',
    NameLabel: 'Ui.Profile.NameLabel',
    NamePlaceholder: 'Ui.Profile.NamePlaceholder',
    AvatarSectionAria: 'Ui.Profile.AvatarSectionAria',
    AvatarLabel: 'Ui.Profile.AvatarLabel',
    AvatarUpload: 'Ui.Profile.AvatarUpload',
    AvatarUploading: 'Ui.Profile.AvatarUploading',
    WpmSectionAria: 'Ui.Profile.WpmSectionAria',
    WpmLabel: 'Ui.Profile.WpmLabel',
    WpmSuffix: 'Ui.Profile.WpmSuffix',
    WpmNumberAria: 'Ui.Profile.WpmNumberAria',
    WpmHint: 'Ui.Profile.WpmHint',
    SaveAria: 'Ui.Profile.SaveAria',
    Saving: 'Ui.Profile.Saving',
    Save: 'Ui.Profile.Save',
    Saved: 'Ui.Profile.Saved',
    CreditsSectionAria: 'Ui.Profile.CreditsSectionAria',
    StorageSectionAria: 'Ui.Profile.StorageSectionAria',
    AiCreditsLabel: 'Ui.Profile.AiCreditsLabel',
    AiCreditsSuffix: 'Ui.Profile.AiCreditsSuffix',
    IncludedThisMonth: 'Ui.Profile.IncludedThisMonth',
    PracticesLeftToday: 'Ui.Profile.PracticesLeftToday',
    ManageSubscription: 'Ui.Profile.ManageSubscription',
    TopUpCredits: 'Ui.Profile.TopUpCredits',
    HelpSectionAria: 'Ui.Profile.HelpSectionAria',
    HelpLabel: 'Ui.Profile.HelpLabel',
    PricingLink: 'Ui.Profile.PricingLink',
    TermsLink: 'Ui.Profile.TermsLink',
    PrivacyLink: 'Ui.Profile.PrivacyLink',
    Contact: 'Ui.Profile.Contact',
    AppVersion: 'Ui.Profile.AppVersion',
    DangerSectionAria: 'Ui.Profile.DangerSectionAria',
    DangerLabel: 'Ui.Profile.DangerLabel',
    DangerCopy: 'Ui.Profile.DangerCopy',
    DeleteMyAccount: 'Ui.Profile.DeleteMyAccount',
    ConfirmCopy: 'Ui.Profile.ConfirmCopy',
    ConfirmEmailLabel: 'Ui.Profile.ConfirmEmailLabel',
    PermanentlyDeleteAria: 'Ui.Profile.PermanentlyDeleteAria',
    Deleting: 'Ui.Profile.Deleting',
    PermanentlyDelete: 'Ui.Profile.PermanentlyDelete',
    Cancel: 'Ui.Profile.Cancel',
    DangerPremiumExport: 'Ui.Profile.DangerPremiumExport',
    TimeZoneSectionAria: 'Ui.Profile.TimeZoneSectionAria',
    TimeZoneLabel: 'Ui.Profile.TimeZoneLabel',
    TimeZoneCurrentTime: 'Ui.Profile.TimeZoneCurrentTime',
    TimeZoneUseDevice: 'Ui.Profile.TimeZoneUseDevice',
    TimeZoneRegionAfrica: 'Ui.Profile.TimeZoneRegionAfrica',
    TimeZoneRegionAmerica: 'Ui.Profile.TimeZoneRegionAmerica',
    TimeZoneRegionAntarctica: 'Ui.Profile.TimeZoneRegionAntarctica',
    TimeZoneRegionArctic: 'Ui.Profile.TimeZoneRegionArctic',
    TimeZoneRegionAsia: 'Ui.Profile.TimeZoneRegionAsia',
    TimeZoneRegionAtlantic: 'Ui.Profile.TimeZoneRegionAtlantic',
    TimeZoneRegionAustralia: 'Ui.Profile.TimeZoneRegionAustralia',
    TimeZoneRegionEurope: 'Ui.Profile.TimeZoneRegionEurope',
    TimeZoneRegionIndian: 'Ui.Profile.TimeZoneRegionIndian',
    TimeZoneRegionPacific: 'Ui.Profile.TimeZoneRegionPacific',
    TimeZoneRegionOther: 'Ui.Profile.TimeZoneRegionOther',
  },
  Support: {
    Title: 'Ui.Support.Title',
    Heading: 'Ui.Support.Heading',
    Intro: 'Ui.Support.Intro',
    FormAria: 'Ui.Support.FormAria',
    EmailLabel: 'Ui.Support.EmailLabel',
    NameLabel: 'Ui.Support.NameLabel',
    SummaryLabel: 'Ui.Support.SummaryLabel',
    DescriptionLabel: 'Ui.Support.DescriptionLabel',
    Submit: 'Ui.Support.Submit',
    Submitting: 'Ui.Support.Submitting',
    Sent: 'Ui.Support.Sent',
    RateLimited: 'Ui.Support.RateLimited',
    Failed: 'Ui.Support.Failed',
    CouldNotVerify: 'Ui.Support.CouldNotVerify',
    RecaptchaNotice: 'Ui.Support.RecaptchaNotice',
  },
  RecordingSettings: {
    SectionAria: 'Ui.RecordingSettings.SectionAria',
    Heading: 'Ui.RecordingSettings.Heading',
    Lede: 'Ui.RecordingSettings.Lede',
    LedeWithoutStorage: 'Ui.RecordingSettings.LedeWithoutStorage',
    AutoSaveLabel: 'Ui.RecordingSettings.AutoSaveLabel',
    AutoSaveHint: 'Ui.RecordingSettings.AutoSaveHint',
    PracticeRemindersLabel: 'Ui.RecordingSettings.PracticeRemindersLabel',
    PracticeRemindersHint: 'Ui.RecordingSettings.PracticeRemindersHint',
    AutoDeleteLabel: 'Ui.RecordingSettings.AutoDeleteLabel',
    AutoDeleteHint: 'Ui.RecordingSettings.AutoDeleteHint',
    KeepDaysLabel: 'Ui.RecordingSettings.KeepDaysLabel',
    KeepDaysUnit: 'Ui.RecordingSettings.KeepDaysUnit',
    KeepDaysAria: 'Ui.RecordingSettings.KeepDaysAria',
    KeepDaysOutOfRange: 'Ui.RecordingSettings.KeepDaysOutOfRange',
    CueLengthLabel: 'Ui.RecordingSettings.CueLengthLabel',
    CueLengthHint: 'Ui.RecordingSettings.CueLengthHint',
    CueLengthShort: 'Ui.RecordingSettings.CueLengthShort',
    CueLengthNormal: 'Ui.RecordingSettings.CueLengthNormal',
    CueLengthLong: 'Ui.RecordingSettings.CueLengthLong',
    DefaultQualityLabel: 'Ui.RecordingSettings.DefaultQualityLabel',
    DefaultQualityHint: 'Ui.RecordingSettings.DefaultQualityHint',
    Save: 'Ui.RecordingSettings.Save',
    Saving: 'Ui.RecordingSettings.Saving',
    Saved: 'Ui.RecordingSettings.Saved',
  },
  UnsubscribeReminders: {
    Title: 'Ui.UnsubscribeReminders.Title',
    Heading: 'Ui.UnsubscribeReminders.Heading',
    Lede: 'Ui.UnsubscribeReminders.Lede',
    Confirm: 'Ui.UnsubscribeReminders.Confirm',
    Working: 'Ui.UnsubscribeReminders.Working',
    Done: 'Ui.UnsubscribeReminders.Done',
    MissingLink: 'Ui.UnsubscribeReminders.MissingLink',
  },
  SaveToLibrary: {
    Heading: 'Ui.SaveToLibrary.Heading',
    Nudge: 'Ui.SaveToLibrary.Nudge',
    Save: 'Ui.SaveToLibrary.Save',
    Saving: 'Ui.SaveToLibrary.Saving',
    UpsellSave: 'Ui.SaveToLibrary.UpsellSave',
    ManageStorage: 'Ui.SaveToLibrary.ManageStorage',
    AddStorage: 'Ui.SaveToLibrary.AddStorage',
    OverLimit: 'Ui.SaveToLibrary.OverLimit',
    NotAvailable: 'Ui.SaveToLibrary.NotAvailable',
    Failed: 'Ui.SaveToLibrary.Failed',
    AutoUploadFailed: 'Ui.SaveToLibrary.AutoUploadFailed',
    OutOfStorage: 'Ui.SaveToLibrary.OutOfStorage',
    PrePracticeWarning: 'Ui.SaveToLibrary.PrePracticeWarning',
    PrePracticeWarningManual: 'Ui.SaveToLibrary.PrePracticeWarningManual',
    UploadingAria: 'Ui.SaveToLibrary.UploadingAria',
    BackgroundSaving: 'Ui.SaveToLibrary.BackgroundSaving',
    BackgroundSavingPercent: 'Ui.SaveToLibrary.BackgroundSavingPercent',
    BackgroundSaved: 'Ui.SaveToLibrary.BackgroundSaved',
    Retry: 'Ui.SaveToLibrary.Retry',
    DismissAria: 'Ui.SaveToLibrary.DismissAria',
    ShowInLibraryAria: 'Ui.SaveToLibrary.ShowInLibraryAria',
  },
  Pricing: {
    Title: 'Ui.Pricing.Title',
    Lede: 'Ui.Pricing.Lede',
    Costs: 'Ui.Pricing.Costs',
    FirstFreeCredits: 'Ui.Pricing.FirstFreeCredits',
    TiersAria: 'Ui.Pricing.TiersAria',
    FreeTitle: 'Ui.Pricing.FreeTitle',
    FreePrice: 'Ui.Pricing.FreePrice',
    FreeFeatureRecordLocally: 'Ui.Pricing.FreeFeatureRecordLocally',
    FreeFeatureDownload: 'Ui.Pricing.FreeFeatureDownload',
    FreeFeatureSignupBonus: 'Ui.Pricing.FreeFeatureSignupBonus',
    FreeFeatureNoServerStorage: 'Ui.Pricing.FreeFeatureNoServerStorage',
    FreeCta: 'Ui.Pricing.FreeCta',
    PacksTitle: 'Ui.Pricing.PacksTitle',
    PacksPrice: 'Ui.Pricing.PacksPrice',
    PacksFeatureSpend: 'Ui.Pricing.PacksFeatureSpend',
    PacksFeatureRetention: 'Ui.Pricing.PacksFeatureRetention',
    PacksFeatureNeverExpire: 'Ui.Pricing.PacksFeatureNeverExpire',
    LegalAgree: 'Ui.Pricing.LegalAgree',
    Redirecting: 'Ui.Pricing.Redirecting',
    BuyPack: 'Ui.Pricing.BuyPack',
    PackSavingPerCredit: 'Ui.Pricing.PackSavingPerCredit',
    PackSavingPerGb: 'Ui.Pricing.PackSavingPerGb',
    PremiumTitle: 'Ui.Pricing.PremiumTitle',
    PremiumPrice: 'Ui.Pricing.PremiumPrice',
    PremiumFeatureCredits: 'Ui.Pricing.PremiumFeatureCredits',
    PremiumFeatureRetention: 'Ui.Pricing.PremiumFeatureRetention',
    PremiumFeatureStorage: 'Ui.Pricing.PremiumFeatureStorage',
    PremiumFeatureOverage: 'Ui.Pricing.PremiumFeatureOverage',
    Loading: 'Ui.Pricing.Loading',
    StartSubscription: 'Ui.Pricing.StartSubscription',
    PremiumCurrentPlan: 'Ui.Pricing.PremiumCurrentPlan',
    PremiumManageLink: 'Ui.Pricing.PremiumManageLink',
    Capacity: 'Ui.Pricing.Capacity',
    WaitlistFormAria: 'Ui.Pricing.WaitlistFormAria',
    WaitlistEmailLabel: 'Ui.Pricing.WaitlistEmailLabel',
    WaitlistJoining: 'Ui.Pricing.WaitlistJoining',
    WaitlistJoin: 'Ui.Pricing.WaitlistJoin',
    DemoTitle: 'Ui.Pricing.DemoTitle',
    DemoLede: 'Ui.Pricing.DemoLede',
    DemoLoading: 'Ui.Pricing.DemoLoading',
    DemoPremiumVoice: 'Ui.Pricing.DemoPremiumVoice',
    DemoPremiumUnavailable: 'Ui.Pricing.DemoPremiumUnavailable',
    DemoFreeVoice: 'Ui.Pricing.DemoFreeVoice',
    DemoFreeUnavailable: 'Ui.Pricing.DemoFreeUnavailable',
    Footnote: 'Ui.Pricing.Footnote',
    MsgStartingCheckout: 'Ui.Pricing.MsgStartingCheckout',
    MsgStartingSubscription: 'Ui.Pricing.MsgStartingSubscription',
    MsgSignInToBuy: 'Ui.Pricing.MsgSignInToBuy',
    MsgSignInToSubscribe: 'Ui.Pricing.MsgSignInToSubscribe',
    MsgUnknownProduct: 'Ui.Pricing.MsgUnknownProduct',
    MsgCheckoutFailed: 'Ui.Pricing.MsgCheckoutFailed',
    MsgAlreadySubscribed: 'Ui.Pricing.MsgAlreadySubscribed',
    MsgPremiumDemoUnavailable: 'Ui.Pricing.MsgPremiumDemoUnavailable',
    MsgFreeDemoUnavailable: 'Ui.Pricing.MsgFreeDemoUnavailable',
    MsgEnterEmail: 'Ui.Pricing.MsgEnterEmail',
    MsgWaitlistFailed: 'Ui.Pricing.MsgWaitlistFailed',
    MsgWaitlistAdmitted: 'Ui.Pricing.MsgWaitlistAdmitted',
    MsgWaitlistSlotOpen: 'Ui.Pricing.MsgWaitlistSlotOpen',
    MsgWaitlistPosition: 'Ui.Pricing.MsgWaitlistPosition',
    TabTitle: 'Ui.Pricing.TabTitle',
    WaitlistEmailPlaceholder: 'Ui.Pricing.WaitlistEmailPlaceholder',
  },
  Billing: {
    Title: 'Ui.Billing.Title',
    LoadingAccount: 'Ui.Billing.LoadingAccount',
    TakingToPricing: 'Ui.Billing.TakingToPricing',
    PremiumPlan: 'Ui.Billing.PremiumPlan',
    StatusActive: 'Ui.Billing.StatusActive',
    StatusCancellationScheduled: 'Ui.Billing.StatusCancellationScheduled',
    StatusPaymentProblem: 'Ui.Billing.StatusPaymentProblem',
    AriaSubscriptionActive: 'Ui.Billing.AriaSubscriptionActive',
    PremiumPriceLine: 'Ui.Billing.PremiumPriceLine',
    RenewsOn: 'Ui.Billing.RenewsOn',
    RenewalInProgress: 'Ui.Billing.RenewalInProgress',
    KeepPremiumUntil: 'Ui.Billing.KeepPremiumUntil',
    PeriodEnd: 'Ui.Billing.PeriodEnd',
    PastDueMeta: 'Ui.Billing.PastDueMeta',
    Opening: 'Ui.Billing.Opening',
    ManageInPortal: 'Ui.Billing.ManageInPortal',
    Cancelling: 'Ui.Billing.Cancelling',
    CancelSubscription: 'Ui.Billing.CancelSubscription',
    FreePlan: 'Ui.Billing.FreePlan',
    AriaFreePlan: 'Ui.Billing.AriaFreePlan',
    FreeBadge: 'Ui.Billing.FreeBadge',
    FreePlanMeta: 'Ui.Billing.FreePlanMeta',
    StartingCheckout: 'Ui.Billing.StartingCheckout',
    UpgradeToPremium: 'Ui.Billing.UpgradeToPremium',
    AiCredits: 'Ui.Billing.AiCredits',
    PaidPlusPremium: 'Ui.Billing.PaidPlusPremium',
    PremiumCreditsRemaining: 'Ui.Billing.PremiumCreditsRemaining',
    MonthlyUsage: 'Ui.Billing.MonthlyUsage',
    AllowanceResets: 'Ui.Billing.AllowanceResets',
    AllowanceResetPending: 'Ui.Billing.AllowanceResetPending',
    CreditsRemaining: 'Ui.Billing.CreditsRemaining',
    Costs: 'Ui.Billing.Costs',
    DailyPractice: 'Ui.Billing.DailyPractice',
    PracticesLeftToday: 'Ui.Billing.PracticesLeftToday',
    LoadingPracticeBalance: 'Ui.Billing.LoadingPracticeBalance',
    BuyMoreCredits: 'Ui.Billing.BuyMoreCredits',
    BuyLedePremium: 'Ui.Billing.BuyLedePremium',
    BuyLedeFree: 'Ui.Billing.BuyLedeFree',
    PaymentHistory: 'Ui.Billing.PaymentHistory',
    LoadingInvoices: 'Ui.Billing.LoadingInvoices',
    ViewReceipt: 'Ui.Billing.ViewReceipt',
    NoPayments: 'Ui.Billing.NoPayments',
    ProgressLink: 'Ui.Billing.ProgressLink',
    MsgOpeningPortal: 'Ui.Billing.MsgOpeningPortal',
    MsgNoBillingAccount: 'Ui.Billing.MsgNoBillingAccount',
    MsgPleaseSignIn: 'Ui.Billing.MsgPleaseSignIn',
    MsgPortalFailed: 'Ui.Billing.MsgPortalFailed',
    MsgAlreadySubscribed: 'Ui.Billing.MsgAlreadySubscribed',
    MsgCheckoutFailed: 'Ui.Billing.MsgCheckoutFailed',
    MsgSignInToBuy: 'Ui.Billing.MsgSignInToBuy',
    MsgUnknownProduct: 'Ui.Billing.MsgUnknownProduct',
    MsgCancelling: 'Ui.Billing.MsgCancelling',
    MsgNoActiveSubscription: 'Ui.Billing.MsgNoActiveSubscription',
    MsgCancelFailed: 'Ui.Billing.MsgCancelFailed',
    MsgCancellationScheduled: 'Ui.Billing.MsgCancellationScheduled',
    Storage: 'Ui.Billing.Storage',
    StorageUsage: 'Ui.Billing.StorageUsage',
    StorageUsageAria: 'Ui.Billing.StorageUsageAria',
    StorageTopUps: 'Ui.Billing.StorageTopUps',
    StorageTopUpsLede: 'Ui.Billing.StorageTopUpsLede',
    StorageBuyPack: 'Ui.Billing.StorageBuyPack',
    StoragePackPriceLine: 'Ui.Billing.StoragePackPriceLine',
    MsgTopUpRequiresPremium: 'Ui.Billing.MsgTopUpRequiresPremium',
    Resubscribe: 'Ui.Billing.Resubscribe',
    EndingOn: 'Ui.Billing.EndingOn',
    EndingSoon: 'Ui.Billing.EndingSoon',
    EndingArchiveNote: 'Ui.Billing.EndingArchiveNote',
    MsgSignInToResubscribe: 'Ui.Billing.MsgSignInToResubscribe',
    TabTitle: 'Ui.Billing.TabTitle',
    InvoiceStatusAria: 'Ui.Billing.InvoiceStatusAria',
  },
  RecordingElsewhere: {
    Heading: 'Ui.RecordingElsewhere.Heading',
    DismissAria: 'Ui.RecordingElsewhere.DismissAria',
    Body: 'Ui.RecordingElsewhere.Body',
    OkAria: 'Ui.RecordingElsewhere.OkAria',
    Ok: 'Ui.RecordingElsewhere.Ok',
    StopStartAria: 'Ui.RecordingElsewhere.StopStartAria',
    StopStartIdle: 'Ui.RecordingElsewhere.StopStartIdle',
    StopStartStopping: 'Ui.RecordingElsewhere.StopStartStopping',
    CloseBlockedHint: 'Ui.RecordingElsewhere.CloseBlockedHint',
    CloseBlockedAck: 'Ui.RecordingElsewhere.CloseBlockedAck',
    PracticeFallback: 'Ui.RecordingElsewhere.PracticeFallback',
  },
  Impersonation: {
    ActingAs: 'Ui.Impersonation.ActingAs',
    Badge: 'Ui.Impersonation.Badge',
    IdentityAria: 'Ui.Impersonation.IdentityAria',
    SignedInAs: 'Ui.Impersonation.SignedInAs',
    ActingAsDetail: 'Ui.Impersonation.ActingAsDetail',
    Reason: 'Ui.Impersonation.Reason',
    StopAria: 'Ui.Impersonation.StopAria',
    StopIdle: 'Ui.Impersonation.StopIdle',
    StopStopping: 'Ui.Impersonation.StopStopping',
    FailedToStop: 'Ui.Impersonation.FailedToStop',
    ActionUnavailable: 'Ui.Impersonation.ActionUnavailable',
  },
  SignUpCta: {
    SectionAria: 'Ui.SignUpCta.SectionAria',
    NeedAccountReason: 'Ui.SignUpCta.NeedAccountReason',
    NeedAccountPrimary: 'Ui.SignUpCta.NeedAccountPrimary',
    NeedAccountSecondary: 'Ui.SignUpCta.NeedAccountSecondary',
    OutOfCreditsReason: 'Ui.SignUpCta.OutOfCreditsReason',
    OutOfCreditsPrimary: 'Ui.SignUpCta.OutOfCreditsPrimary',
    OutOfCreditsSecondary: 'Ui.SignUpCta.OutOfCreditsSecondary',
    GuestReason: 'Ui.SignUpCta.GuestReason',
    GuestPrimary: 'Ui.SignUpCta.GuestPrimary',
    GuestSecondary: 'Ui.SignUpCta.GuestSecondary',
    GuestPracticeReason: 'Ui.SignUpCta.GuestPracticeReason',
    GuestUploadReason: 'Ui.SignUpCta.GuestUploadReason',
    PremiumRehearsalReason: 'Ui.SignUpCta.PremiumRehearsalReason',
    PremiumProgressReason: 'Ui.SignUpCta.PremiumProgressReason',
    PremiumPlansReason: 'Ui.SignUpCta.PremiumPlansReason',
    GuestClaimReason: 'Ui.SignUpCta.GuestClaimReason',
    PremiumPracticePrimary: 'Ui.SignUpCta.PremiumPracticePrimary',
    PreviewBadge: 'Ui.SignUpCta.PreviewBadge',
    PreviewNote: 'Ui.SignUpCta.PreviewNote',
    PreviewAria: 'Ui.SignUpCta.PreviewAria',
  },
  SessionPanel: {
    StillLoading: 'Ui.SessionPanel.StillLoading',
    NetworkError: 'Ui.SessionPanel.NetworkError',
    CannotEnd: 'Ui.SessionPanel.CannotEnd',
    ConfirmEnd: 'Ui.SessionPanel.ConfirmEnd',
    ConfirmLeave: 'Ui.SessionPanel.ConfirmLeave',
    AwaitingHint: 'Ui.SessionPanel.AwaitingHint',
    DurationLabel: 'Ui.SessionPanel.DurationLabel',
    PersonaliseLabel: 'Ui.SessionPanel.PersonaliseLabel',
    PersonaliseFieldLabel: 'Ui.SessionPanel.PersonaliseFieldLabel',
    PersonalisePlaceholder: 'Ui.SessionPanel.PersonalisePlaceholder',
    PersonaliseAriaLabel: 'Ui.SessionPanel.PersonaliseAriaLabel',
    SessionDurationAria: 'Ui.SessionPanel.SessionDurationAria',
    QuotaExhaustedLimit: 'Ui.SessionPanel.QuotaExhaustedLimit',
    QuotaExhaustedGuest: 'Ui.SessionPanel.QuotaExhaustedGuest',
    QuotaRemaining: 'Ui.SessionPanel.QuotaRemaining',
    QuotaRemainingOneSession: 'Ui.SessionPanel.QuotaRemainingOneSession',
    QuotaRemainingManySessions: 'Ui.SessionPanel.QuotaRemainingManySessions',
    TimerAria: 'Ui.SessionPanel.TimerAria',
    EndSessionAria: 'Ui.SessionPanel.EndSessionAria',
    StartSessionAria: 'Ui.SessionPanel.StartSessionAria',
    ResumeSessionAria: 'Ui.SessionPanel.ResumeSessionAria',
    EndSession: 'Ui.SessionPanel.EndSession',
    EndSessionEnding: 'Ui.SessionPanel.EndSessionEnding',
    StartSession: 'Ui.SessionPanel.StartSession',
    ResumeSession: 'Ui.SessionPanel.ResumeSession',
    StartSessionStarting: 'Ui.SessionPanel.StartSessionStarting',
    NewSession: 'Ui.SessionPanel.NewSession',
    TimeElapsed: 'Ui.SessionPanel.TimeElapsed',
    StartNewSessionAria: 'Ui.SessionPanel.StartNewSessionAria',
  },
  EditableName: {
    EditAria: 'Ui.EditableName.EditAria',
    RenameTitle: 'Ui.EditableName.RenameTitle',
    DialogHeading: 'Ui.EditableName.DialogHeading',
    NameLabel: 'Ui.EditableName.NameLabel',
    Confirm: 'Ui.EditableName.Confirm',
    Cancel: 'Ui.EditableName.Cancel',
    DismissAria: 'Ui.EditableName.DismissAria',
    Saved: 'Ui.EditableName.Saved',
    Saving: 'Ui.EditableName.Saving',
    Untitled: 'Ui.EditableName.Untitled',
    ErrorEmpty: 'Ui.EditableName.ErrorEmpty',
    ErrorNetwork: 'Ui.EditableName.ErrorNetwork',
    ErrorFailed: 'Ui.EditableName.ErrorFailed',
  },
  ActiveSpine: {
    HowTrackedAria: 'Ui.ActiveSpine.HowTrackedAria',
    AutoTrackingDetail: 'Ui.ActiveSpine.AutoTrackingDetail',
    Progress: 'Ui.ActiveSpine.Progress',
    ProgressZero: 'Ui.ActiveSpine.ProgressZero',
    ProgressWithElement: 'Ui.ActiveSpine.ProgressWithElement',
  },
  PostTakeReview: {
    AwaitingUpload: 'Ui.PostTakeReview.AwaitingUpload',
    TakeComplete: 'Ui.PostTakeReview.TakeComplete',
    MoreActionsAria: 'Ui.PostTakeReview.MoreActionsAria',
    DownloadVideo: 'Ui.PostTakeReview.DownloadVideo',
    DiscardTake: 'Ui.PostTakeReview.DiscardTake',
    DiscardConfirmTitle: 'Ui.PostTakeReview.DiscardConfirmTitle',
    DiscardConfirmBody: 'Ui.PostTakeReview.DiscardConfirmBody',
    Discarded: 'Ui.PostTakeReview.Discarded',
    SeriesLocalOnly: 'Ui.PostTakeReview.SeriesLocalOnly',
    KeepManage: 'Ui.PostTakeReview.KeepManage',
    ReviewSignIn: 'Ui.PostTakeReview.ReviewSignIn',
    ReviewGuestReason: 'Ui.PostTakeReview.ReviewGuestReason',
    ReviewNoCredits: 'Ui.PostTakeReview.ReviewNoCredits',
    StripSavingTitle: 'Ui.PostTakeReview.StripSavingTitle',
    StripSavingSub: 'Ui.PostTakeReview.StripSavingSub',
    StripSavedTitle: 'Ui.PostTakeReview.StripSavedTitle',
    StripSavedSub: 'Ui.PostTakeReview.StripSavedSub',
    StripLocalSub: 'Ui.PostTakeReview.StripLocalSub',
    StripSeePremium: 'Ui.PostTakeReview.StripSeePremium',
    StripCreateAccount: 'Ui.PostTakeReview.StripCreateAccount',
  },
  NameDialog: {
    Heading: 'Ui.NameDialog.Heading',
    NameLabel: 'Ui.NameDialog.NameLabel',
    NamePlaceholder: 'Ui.NameDialog.NamePlaceholder',
    DismissAria: 'Ui.NameDialog.DismissAria',
    SaveAria: 'Ui.NameDialog.SaveAria',
    Save: 'Ui.NameDialog.Save',
    Saving: 'Ui.NameDialog.Saving',
  },
  AboutDialog: {
    Title: 'Ui.AboutDialog.Title',
    CloseAria: 'Ui.AboutDialog.CloseAria',
    App: 'Ui.AboutDialog.App',
    Api: 'Ui.AboutDialog.Api',
    DevChannel: 'Ui.AboutDialog.DevChannel',
    Loading: 'Ui.AboutDialog.Loading',
    Unavailable: 'Ui.AboutDialog.Unavailable',
    BuiltFe: 'Ui.AboutDialog.BuiltFe',
    BuiltApi: 'Ui.AboutDialog.BuiltApi',
  },
  StatusPill: {
    Reviewed: 'Ui.StatusPill.Reviewed',
    PendingReview: 'Ui.StatusPill.PendingReview',
    ReviewFailed: 'Ui.StatusPill.ReviewFailed',
    Recording: 'Ui.StatusPill.Recording',
    Status: 'Ui.StatusPill.Status',
  },
  Transport: {
    Elapsed: 'Ui.Transport.Elapsed',
    StatusRecording: 'Ui.Transport.StatusRecording',
    Pause: 'Ui.Transport.Pause',
    Stop: 'Ui.Transport.Stop',
  },
  MicLevel: {
    MeterAria: 'Ui.MicLevel.MeterAria',
    QuietHint: 'Ui.MicLevel.QuietHint',
  },
  Recording: {
    MusicVolume: 'Ui.Recording.MusicVolume',
    MusicOn: 'Ui.Recording.MusicOn',
    MusicOff: 'Ui.Recording.MusicOff',
    CueVoiceVolume: 'Ui.Recording.CueVoiceVolume',
    CuesOn: 'Ui.Recording.CuesOn',
    CuesOff: 'Ui.Recording.CuesOff',
    PacerOn: 'Ui.Recording.PacerOn',
    PacerOff: 'Ui.Recording.PacerOff',
    PacerAria: 'Ui.Recording.PacerAria',
    PacerUnavailable: 'Ui.Recording.PacerUnavailable',
    PacerUnavailableAria: 'Ui.Recording.PacerUnavailableAria',
    RecoverySteps: 'Ui.Recording.RecoverySteps',
    RecoveryIllustrationAria: 'Ui.Recording.RecoveryIllustrationAria',
    TryAgain: 'Ui.Recording.TryAgain',
    RecordAgain: 'Ui.Recording.RecordAgain',
    LivePreviewAria: 'Ui.Recording.LivePreviewAria',
    StatusStartingCamera: 'Ui.Recording.StatusStartingCamera',
    RerecordConfirmTitle: 'Ui.Recording.RerecordConfirmTitle',
    RerecordConfirm: 'Ui.Recording.RerecordConfirm',
    RerecordCancel: 'Ui.Recording.RerecordCancel',
    DownloadPracticeText: 'Ui.Recording.DownloadPracticeText',
    MusicStatusMood: 'Ui.Recording.MusicStatusMood',
    MusicStatusArchetype: 'Ui.Recording.MusicStatusArchetype',
    MusicStatusMuted: 'Ui.Recording.MusicStatusMuted',
    MusicStatusPaused: 'Ui.Recording.MusicStatusPaused',
  },
  ReviewPack: {
    Download: 'Ui.ReviewPack.Download',
    Pending: 'Ui.ReviewPack.Pending',
    PreparingPack: 'Ui.ReviewPack.PreparingPack',
    Saved: 'Ui.ReviewPack.Saved',
    ErrorSignIn: 'Ui.ReviewPack.ErrorSignIn',
    ErrorForbidden: 'Ui.ReviewPack.ErrorForbidden',
    ErrorGone: 'Ui.ReviewPack.ErrorGone',
    ErrorPending: 'Ui.ReviewPack.ErrorPending',
    ErrorUnavailable: 'Ui.ReviewPack.ErrorUnavailable',
    ErrorGeneric: 'Ui.ReviewPack.ErrorGeneric',
  },
  RecordingSetup: {
    BlurUnavailable: 'Ui.RecordingSetup.BlurUnavailable',
    PermissionDenied: 'Ui.RecordingSetup.PermissionDenied',
    Camera: 'Ui.RecordingSetup.Camera',
    Microphone: 'Ui.RecordingSetup.Microphone',
    BlurOn: 'Ui.RecordingSetup.BlurOn',
    BlurOff: 'Ui.RecordingSetup.BlurOff',
    NoiseReductionOn: 'Ui.RecordingSetup.NoiseReductionOn',
    NoiseReductionOff: 'Ui.RecordingSetup.NoiseReductionOff',
    NoiseReductionLocked: 'Ui.RecordingSetup.NoiseReductionLocked',
    VideoQualityLocked: 'Ui.RecordingSetup.VideoQualityLocked',
    VideoQualityCycleAria: 'Ui.RecordingSetup.VideoQualityCycleAria',
    NoiseReductionOffNotice: 'Ui.RecordingSetup.NoiseReductionOffNotice',
    BlurLimitsQuality: 'Ui.RecordingSetup.BlurLimitsQuality',
    BlurDisabledByPick: 'Ui.RecordingSetup.BlurDisabledByPick',
    PreviewFailed: 'Ui.RecordingSetup.PreviewFailed',
    CameraFallback: 'Ui.RecordingSetup.CameraFallback',
    MicrophoneFallback: 'Ui.RecordingSetup.MicrophoneFallback',
  },
  Playback: {
    VideoAria: 'Ui.Playback.VideoAria',
    Play: 'Ui.Playback.Play',
    Pause: 'Ui.Playback.Pause',
    CurrentTime: 'Ui.Playback.CurrentTime',
    SeekAria: 'Ui.Playback.SeekAria',
    TotalDuration: 'Ui.Playback.TotalDuration',
    Unsupported: 'Ui.Playback.Unsupported',
    Loading: 'Ui.Playback.Loading',
    CoachingCuesCount: 'Ui.Playback.CoachingCuesCount',
    CueSeekHint: 'Ui.Playback.CueSeekHint',
  },
  Offline: {
    BuiltWithLlama: 'Ui.Offline.BuiltWithLlama',
    AccuracyNote: 'Ui.Offline.AccuracyNote',
    LicencesLink: 'Ui.Offline.LicencesLink',
    ToggleAria: 'Ui.Offline.ToggleAria',
    Title: 'Ui.Offline.Title',
    Subtitle: 'Ui.Offline.Subtitle',
    Advanced: 'Ui.Offline.Advanced',
    AdvancedHint: 'Ui.Offline.AdvancedHint',
    ModelLabel: 'Ui.Offline.ModelLabel',
    ShowAll: 'Ui.Offline.ShowAll',
    TierTiny: 'Ui.Offline.TierTiny',
    TierSmall: 'Ui.Offline.TierSmall',
    TierMedium: 'Ui.Offline.TierMedium',
    TierLarge: 'Ui.Offline.TierLarge',
    Recommended: 'Ui.Offline.Recommended',
    StateDownloading: 'Ui.Offline.StateDownloading',
    StateLoading: 'Ui.Offline.StateLoading',
    StateReady: 'Ui.Offline.StateReady',
    LoadFailed: 'Ui.Offline.LoadFailed',
    TooShort: 'Ui.Offline.TooShort',
    Repetitive: 'Ui.Offline.Repetitive',
    Incoherent: 'Ui.Offline.Incoherent',
    WorkerMessageFailed: 'Ui.Offline.WorkerMessageFailed',
    CatalogUnavailable: 'Ui.Offline.CatalogUnavailable',
    OfferTitle: 'Ui.Offline.OfferTitle',
    OfferBody: 'Ui.Offline.OfferBody',
    OfferAccept: 'Ui.Offline.OfferAccept',
    OfferDecline: 'Ui.Offline.OfferDecline',
    OfferPrivacy: 'Ui.Offline.OfferPrivacy',
  },
  StandaloneUpload: {
    UploadRecording: 'Ui.StandaloneUpload.UploadRecording',
    Reviewing: 'Ui.StandaloneUpload.Reviewing',
    ChooseDifferent: 'Ui.StandaloneUpload.ChooseDifferent',
    ErrorContentType: 'Ui.StandaloneUpload.ErrorContentType',
    ErrorSize: 'Ui.StandaloneUpload.ErrorSize',
    ErrorSignIn: 'Ui.StandaloneUpload.ErrorSignIn',
  },
  Streaming: {
    Preparing: 'Ui.Streaming.Preparing',
    GenerationFailed: 'Ui.Streaming.GenerationFailed',
    TryAgain: 'Ui.Streaming.TryAgain',
    YourWord: 'Ui.Streaming.YourWord',
    PreparingCues: 'Ui.Streaming.PreparingCues',
  },
  PracticeView: {
    AiGuide: 'Ui.PracticeView.AiGuide',
    KindToReadAloud: 'Ui.PracticeView.KindToReadAloud',
    TokenCount: 'Ui.PracticeView.TokenCount',
    ContentError: 'Ui.PracticeView.ContentError',
    ContentLoading: 'Ui.PracticeView.ContentLoading',
    CuesSoFar: 'Ui.PracticeView.CuesSoFar',
    CueLiveNow: 'Ui.PracticeView.CueLiveNow',
    ReadAloud: 'Ui.PracticeView.ReadAloud',
  },
  Search: {
    Label: 'Ui.Search.Label',
    Placeholder: 'Ui.Search.Placeholder',
    Clear: 'Ui.Search.Clear',
    ResultsOne: 'Ui.Search.ResultsOne',
    ResultsMany: 'Ui.Search.ResultsMany',
    NoMatch: 'Ui.Search.NoMatch',
    NoMatchFiltered: 'Ui.Search.NoMatchFiltered',
  },
  Errors: {
    Unexpected: 'Ui.Errors.Unexpected',
  },
  LocalCache: {
    StorageFull: 'Ui.LocalCache.StorageFull',
    SaveFailed: 'Ui.LocalCache.SaveFailed',
    ListFailed: 'Ui.LocalCache.ListFailed',
    FallbackTakeName: 'Ui.LocalCache.FallbackTakeName',
  },
  Pending: {
    CreditsSettingUp: 'Ui.Pending.CreditsSettingUp',
    CreditsStuck: 'Ui.Pending.CreditsStuck',
    PurchaseApplying: 'Ui.Pending.PurchaseApplying',
    PurchaseStuck: 'Ui.Pending.PurchaseStuck',
    PlanStuck: 'Ui.Pending.PlanStuck',
    ParseStuck: 'Ui.Pending.ParseStuck',
    ReviewStuck: 'Ui.Pending.ReviewStuck',
    Retry: 'Ui.Pending.Retry',
  },
  DataExport: {
    Title: 'Ui.DataExport.Title',
    Heading: 'Ui.DataExport.Heading',
    Intro: 'Ui.DataExport.Intro',
    ManagerTip: 'Ui.DataExport.ManagerTip',
    DownloadAll: 'Ui.DataExport.DownloadAll',
    CopyAll: 'Ui.DataExport.CopyAll',
    Copied: 'Ui.DataExport.Copied',
    FilesHeading: 'Ui.DataExport.FilesHeading',
    Loading: 'Ui.DataExport.Loading',
    Expired: 'Ui.DataExport.Expired',
    NotFound: 'Ui.DataExport.NotFound',
    Failed: 'Ui.DataExport.Failed',
  },
  Thinking: {
    WarmingUp: 'Ui.Thinking.WarmingUp',
    ClearingThroat: 'Ui.Thinking.ClearingThroat',
    Humming: 'Ui.Thinking.Humming',
    DeepBreath: 'Ui.Thinking.DeepBreath',
    Siren: 'Ui.Thinking.Siren',
    FindingPitch: 'Ui.Thinking.FindingPitch',
    LowerRegister: 'Ui.Thinking.LowerRegister',
    Pausing: 'Ui.Thinking.Pausing',
    Projecting: 'Ui.Thinking.Projecting',
    Articulating: 'Ui.Thinking.Articulating',
    TongueTwisters: 'Ui.Thinking.TongueTwisters',
    Pacing: 'Ui.Thinking.Pacing',
    Legato: 'Ui.Thinking.Legato',
    Staccato: 'Ui.Thinking.Staccato',
    LooseningJaw: 'Ui.Thinking.LooseningJaw',
    WarmWater: 'Ui.Thinking.WarmWater',
    Mirror: 'Ui.Thinking.Mirror',
    MarkingScript: 'Ui.Thinking.MarkingScript',
    PowerSphere: 'Ui.Thinking.PowerSphere',
    FindingVoice: 'Ui.Thinking.FindingVoice',
  },
  CreditLedger: {
    EventsEmpty: 'Ui.CreditLedger.EventsEmpty',
    ColumnDate: 'Ui.CreditLedger.ColumnDate',
    ColumnType: 'Ui.CreditLedger.ColumnType',
    ColumnAmount: 'Ui.CreditLedger.ColumnAmount',
    ColumnBalance: 'Ui.CreditLedger.ColumnBalance',
    TypeAdminAdjust: 'Ui.CreditLedger.TypeAdminAdjust',
    SourceAiReview: 'Ui.CreditLedger.SourceAiReview',
    SourceActiveListening: 'Ui.CreditLedger.SourceActiveListening',
    SourceLiveConvo: 'Ui.CreditLedger.SourceLiveConvo',
    SourceRehearsalPlan: 'Ui.CreditLedger.SourceRehearsalPlan',
    SourceRehearsalPdfRecognition: 'Ui.CreditLedger.SourceRehearsalPdfRecognition',
    TakeUnsaved: 'Ui.CreditLedger.TakeUnsaved',
    Refund: 'Ui.CreditLedger.Refund',
    TypeSupportAdjust: 'Ui.CreditLedger.TypeSupportAdjust',
    Heading: 'Ui.CreditLedger.Heading',
    Lede: 'Ui.CreditLedger.Lede',
    ShowMore: 'Ui.CreditLedger.ShowMore',
    Loading: 'Ui.CreditLedger.Loading',
    LoadFailed: 'Ui.CreditLedger.LoadFailed',
    TypeSignupBonus: 'Ui.CreditLedger.TypeSignupBonus',
    Pack: 'Ui.CreditLedger.Pack',
    PackRefund: 'Ui.CreditLedger.PackRefund',
    MonthlyAllowance: 'Ui.CreditLedger.MonthlyAllowance',
    AllowanceLapsed: 'Ui.CreditLedger.AllowanceLapsed',
    AllowanceDebtRepaid: 'Ui.CreditLedger.AllowanceDebtRepaid',
    SourceLivePitch: 'Ui.CreditLedger.SourceLivePitch',
    SourceDeliveryPlan: 'Ui.CreditLedger.SourceDeliveryPlan',
    SourceRewrite: 'Ui.CreditLedger.SourceRewrite',
    LiveMinutes: 'Ui.CreditLedger.LiveMinutes',
    Settled: 'Ui.CreditLedger.Settled',
    Settling: 'Ui.CreditLedger.Settling',
    RefundedInFull: 'Ui.CreditLedger.RefundedInFull',
    TimesIn: 'Ui.CreditLedger.TimesIn',
  },
  CreditReceipt: {
    ChargedOne: 'Ui.CreditReceipt.ChargedOne',
    ChargedMany: 'Ui.CreditReceipt.ChargedMany',
    SettledOne: 'Ui.CreditReceipt.SettledOne',
    SettledMany: 'Ui.CreditReceipt.SettledMany',
    LiveOne: 'Ui.CreditReceipt.LiveOne',
    LiveMany: 'Ui.CreditReceipt.LiveMany',
    HistoryLink: 'Ui.CreditReceipt.HistoryLink',
  },
  SelfReview: {
    ModesAria: 'Ui.SelfReview.ModesAria',
    NormalPlayback: 'Ui.SelfReview.NormalPlayback',
    Visual: 'Ui.SelfReview.Visual',
    Auditory: 'Ui.SelfReview.Auditory',
    Transcript: 'Ui.SelfReview.Transcript',
    VisualShort: 'Ui.SelfReview.VisualShort',
    AuditoryShort: 'Ui.SelfReview.AuditoryShort',
    TranscriptShort: 'Ui.SelfReview.TranscriptShort',
    ChecksAria: 'Ui.SelfReview.ChecksAria',
    CheckDoneAria: 'Ui.SelfReview.CheckDoneAria',
    CheckNotDoneAria: 'Ui.SelfReview.CheckNotDoneAria',
    Saving: 'Ui.SelfReview.Saving',
    Done: 'Ui.SelfReview.Done',
  },
  HomeMove: {
    Banner: 'Ui.HomeMove.Banner',
    BannerUnknownRegion: 'Ui.HomeMove.BannerUnknownRegion',
    Region: {
      Na: 'Ui.HomeMove.Region.Na',
      Au: 'Ui.HomeMove.Region.Au',
      Sg: 'Ui.HomeMove.Region.Sg',
    },
  },
} as const;

export const UiValues = {
  'default': {
    'AboutDialog.Api': 'API',
    'AboutDialog.App': 'App',
    'AboutDialog.BuiltApi': 'Built (API)',
    'AboutDialog.BuiltFe': 'Built (FE)',
    'AboutDialog.CloseAria': 'Close',
    'AboutDialog.DevChannel': 'DEV',
    'AboutDialog.Loading': 'loading…',
    'AboutDialog.Title': 'VoiceDojo',
    'AboutDialog.Unavailable': 'unavailable ({Error})',
    'Account.AdminConsole': 'Admin console',
    'Account.AiCredits': 'AI credits',
    'Account.BadgeAdmin': 'Admin',
    'Account.BadgeGuest': 'Guest',
    'Account.BadgePremium': 'Premium',
    'Account.BalancesAria': 'Your balances',
    'Account.DailyPracticesLeftAria': 'Daily practices left',
    'Account.Greeting': 'G\'day {Name}',
    'Account.Language': 'Language',
    'Account.MenuAria': 'Account menu',
    'Account.PracticesLeftDetail': '{Remaining} of {Limit} practices left today',
    'Account.PracticesLeftMany': '{Remaining} practices left',
    'Account.PracticesLeftOne': '{Remaining} practice left',
    'Account.PracticesLeftToday': 'of {Limit} practices left today',
    'Account.Preferences': 'Preferences',
    'Account.Profile': 'Profile',
    'Account.Reviews': 'AI Reviews',
    'Account.SignIn': 'Sign in',
    'Account.SignOut': 'Sign out',
    'Account.SpendableBreakdown': '{Paid} paid · {Monthly} monthly',
    'Account.Subscription': 'Subscription',
    'Account.Theme': 'Theme',
    'Account.Version': 'Version {Version}',
    'ActiveSpine.AutoTrackingDetail': 'Your current practice is tracked automatically — recordings this week are saved to your spine so you can review them later.',
    'ActiveSpine.HowTrackedAria': 'How is my practice tracked?',
    'ActiveSpine.Progress': 'You\'re **{Reps}** into your **{Target}** reps for your mastery spine this week{Element}! Way to go! 🎯',
    'ActiveSpine.ProgressWithElement': ' ({Element})',
    'ActiveSpine.ProgressZero': 'No reps yet toward your **{Target}** for your mastery spine this week{Element}. The first take starts it. 🎯',
    'Billing.AiCredits': 'AI credits',
    'Billing.AllowanceResetPending': 'Your allowance resets as soon as the renewal for {PeriodEnd} settles.',
    'Billing.AllowanceResets': 'Allowance resets **{Date}**.',
    'Billing.AriaFreePlan': 'Free plan',
    'Billing.AriaSubscriptionActive': 'Subscription active',
    'Billing.BuyLedeFree': 'Credits never expire — top up to run more AI Reviews and Active Listening.',
    'Billing.BuyLedePremium': 'Credits never expire and stack on top of your monthly Premium allowance.',
    'Billing.BuyMoreCredits': 'Buy more credits',
    'Billing.CancelSubscription': 'Cancel subscription',
    'Billing.Cancelling': 'Cancelling…',
    'Billing.Costs': 'Costs: AI Review from {ReviewFrom} credit (dialable) · Active Listening {ActiveListening} credit',
    'Billing.CreditsRemaining': 'credits remaining',
    'Billing.DailyPractice': 'Daily practice',
    'Billing.EndingArchiveNote': 'Saved recordings will be archived for 30 days after that, then deleted. Resubscribe to keep them.',
    'Billing.EndingOn': 'Your Premium ends on {Date}',
    'Billing.EndingSoon': 'Your Premium ends soon',
    'Billing.FreeBadge': 'Free',
    'Billing.FreePlan': 'Free plan',
    'Billing.FreePlanMeta': 'You\'re on the free plan — daily practices plus pay-per-credit AI actions. Go Premium for a monthly credit allowance, {Storage} storage, and more.',
    'Billing.InvoiceStatusAria': 'Invoice {Status}',
    'Billing.KeepPremiumUntil': 'You\'ll keep Premium until **{Date}**.',
    'Billing.LoadingAccount': 'Loading account…',
    'Billing.LoadingInvoices': 'Loading your invoices…',
    'Billing.LoadingPracticeBalance': 'Loading today\'s practice balance…',
    'Billing.ManageInPortal': 'Manage in Stripe portal',
    'Billing.MonthlyUsage': 'Used {Used} of your {Total} monthly credits.',
    'Billing.MsgAlreadySubscribed': 'You already have an active subscription.',
    'Billing.MsgCancelFailed': 'Could not cancel subscription. Please try again.',
    'Billing.MsgCancellationScheduled': 'Cancellation scheduled. You will keep Premium until the period ends.',
    'Billing.MsgCancelling': 'Cancelling subscription…',
    'Billing.MsgCheckoutFailed': 'Could not start checkout. Please try again.',
    'Billing.MsgNoActiveSubscription': 'No active subscription to cancel.',
    'Billing.MsgNoBillingAccount': 'No billing account yet — make a purchase first.',
    'Billing.MsgOpeningPortal': 'Opening billing portal…',
    'Billing.MsgPleaseSignIn': 'Please sign in.',
    'Billing.MsgPortalFailed': 'Could not open the billing portal. Please try again.',
    'Billing.MsgSignInToBuy': 'Please sign in to purchase credits.',
    'Billing.MsgSignInToResubscribe': 'Please sign in to resubscribe.',
    'Billing.MsgTopUpRequiresPremium': 'Storage top-ups are Premium only — upgrade to Premium first.',
    'Billing.MsgUnknownProduct': 'Unknown product. Please refresh the page and try again.',
    'Billing.NoPayments': 'No payments yet. Your invoices will appear here after your first charge.',
    'Billing.Opening': 'Opening…',
    'Billing.PaidPlusPremium': 'paid + ',
    'Billing.PastDueMeta': 'Your latest payment failed — we retain Premium while Stripe retries. Update your payment method in the customer portal.',
    'Billing.PaymentHistory': 'Payment history',
    'Billing.PeriodEnd': 'the end of the current period',
    'Billing.PracticesLeftToday': 'practices left today',
    'Billing.PremiumCreditsRemaining': 'Premium credits remaining this month',
    'Billing.PremiumPlan': 'Premium',
    'Billing.PremiumPriceLine': '${Price} / month · {Credits} credits/mo',
    'Billing.ProgressLink': 'Tracking the 12-week plan? See your [Progress](/progress).',
    'Billing.RenewalInProgress': 'Your renewal for {PeriodEnd} is being processed — your Premium stays active while it settles.',
    'Billing.RenewsOn': 'Renews on **{Date}**.',
    'Billing.Resubscribe': 'Resubscribe',
    'Billing.StartingCheckout': 'Starting checkout…',
    'Billing.StatusActive': 'Active',
    'Billing.StatusCancellationScheduled': 'Cancellation scheduled',
    'Billing.StatusPaymentProblem': 'Payment problem',
    'Billing.Storage': 'Cloud storage',
    'Billing.StorageBuyPack': 'Add {Size}',
    'Billing.StoragePackPriceLine': '${Price} / month',
    'Billing.StorageTopUps': 'Add more storage',
    'Billing.StorageTopUpsLede': 'Recurring monthly top-ups extend your Premium storage allowance. They lapse if Premium ends.',
    'Billing.StorageUsage': '{Used} of {Limit} used',
    'Billing.StorageUsageAria': 'Using {Used} of {Limit} cloud storage ({Percent}%).',
    'Billing.TabTitle': 'Billing & account · VoiceDojo',
    'Billing.TakingToPricing': 'Taking you to pricing…',
    'Billing.Title': 'Billing & account',
    'Billing.UpgradeToPremium': 'Upgrade to Premium',
    'Billing.ViewReceipt': 'View receipt',
    'BillingCancel.BackToPricing': 'Back to pricing',
    'BillingCancel.BuyCredits': 'Buy credits',
    'BillingCancel.CheckoutFailed': 'Couldn\'t start checkout, please try again.',
    'BillingCancel.Heading': 'Payment didn\'t go through',
    'BillingCancel.KeepPractising': 'Keep practising',
    'BillingCancel.Lede': 'No worries — **you weren\'t charged and nothing changed.** Your account is exactly where you left it. Want to give it another go?',
    'BillingCancel.Redirecting': 'Redirecting…',
    'BillingCancel.Title': 'Payment didn\'t go through · VoiceDojo',
    'BillingCancel.TryAgain': 'Try again',
    'BillingSuccess.AiCredits': 'AI credits',
    'BillingSuccess.Cancel': 'Cancel',
    'BillingSuccess.CheckBalance': 'Check your balance',
    'BillingSuccess.CheckEmailBody': 'We sent a sign-in link to {Email}. Click it (or enter the code) to finish unlocking your purchase.',
    'BillingSuccess.CheckEmailHeading': 'Check your email',
    'BillingSuccess.ClaimError': 'Something went wrong sending the link. Try again.',
    'BillingSuccess.CloudStorage': 'Cloud storage',
    'BillingSuccess.CollisionBody': 'An account already exists under {Email}. Confirm it\'s yours and we\'ll email you a sign-in link to finish.',
    'BillingSuccess.CollisionConfirm': 'Yes, send me the link',
    'BillingSuccess.CollisionDeny': 'No, use a different email',
    'BillingSuccess.CollisionTitle': 'Is this you?',
    'BillingSuccess.ConfirmEmailBody': 'We\'ll email a sign-in link to confirm this is you and unlock your purchase.',
    'BillingSuccess.ConfirmEmailHeading': 'Confirm your email to finish',
    'BillingSuccess.DailyPracticesLeft': 'Daily practices left',
    'BillingSuccess.EmailLabel': 'Email',
    'BillingSuccess.EmailRequired': 'Enter an email address.',
    'BillingSuccess.Finalising': 'Finalising your purchase…',
    'BillingSuccess.FinalisingBody': 'One moment while we confirm your payment.',
    'BillingSuccess.GoToBilling': 'Go to billing',
    'BillingSuccess.MonthlyCreditsLeft': 'Monthly credits left',
    'BillingSuccess.NameLabel': 'Your name',
    'BillingSuccess.NameOptional': 'Your name (optional)',
    'BillingSuccess.OtpEnterCode': 'Enter the 6-digit code from the email.',
    'BillingSuccess.OtpExpired': 'That code has expired — resend the link for a fresh one.',
    'BillingSuccess.OtpInvalid': 'That code didn\'t match. Check the email and try again.',
    'BillingSuccess.OtpLabel': 'Or enter the 6-digit code',
    'BillingSuccess.OtpTooManyAttempts': 'Too many attempts. Resend the link for a fresh code.',
    'BillingSuccess.QuotaOf': '{Remaining} of {Limit}',
    'BillingSuccess.ReceiptGeneric': 'Payment complete',
    'BillingSuccess.ReceiptGenericBody': 'Thanks — your purchase is confirmed.',
    'BillingSuccess.ReceiptPack': 'You added {Pack}',
    'BillingSuccess.ReceiptPackBody': 'Your credits are ready to spend.',
    'BillingSuccess.ReceiptSubscription': 'You\'re now Premium',
    'BillingSuccess.ReceiptSubscriptionBody': 'Your subscription is active — {Credits} credits/month included.',
    'BillingSuccess.ReceiptTopUp': 'Storage added',
    'BillingSuccess.ReceiptTopUpBody': 'Your {Size} storage top-up is active — extra room to save your takes.',
    'BillingSuccess.Recovery': 'To use VoiceDojo on another device, sign in with your email — no password, just a sign-in link.',
    'BillingSuccess.ResendLink': 'Resend link',
    'BillingSuccess.SaveAccountHeading': 'Save your account',
    'BillingSuccess.SavedNoEmail': 'Your account is saved under the email you paid with.',
    'BillingSuccess.SavedUnder': 'Saved under **{Email}**.',
    'BillingSuccess.SendLink': 'Send link',
    'BillingSuccess.SendingLink': 'Sending link…',
    'BillingSuccess.StartPractising': 'Start practising',
    'BillingSuccess.Title': 'Payment complete · VoiceDojo',
    'BillingSuccess.Updating': 'Updating your balance… this is taking a little longer than usual.',
    'BillingSuccess.UseDifferentEmail': 'Use a different email',
    'BillingSuccess.Verifying': 'Verifying…',
    'CheckoutEmail.Body': 'Your credits and Premium live under your email, so we ask for it before you pay — that way the purchase lands on the account you already have, not a second one.',
    'CheckoutEmail.Cancel': 'Cancel',
    'CheckoutEmail.Continue': 'Continue to payment',
    'CheckoutEmail.EmailInvalid': 'That doesn\'t look like an email address.',
    'CheckoutEmail.EmailLabel': 'Email',
    'CheckoutEmail.EmailRequired': 'Enter your email to continue.',
    'CheckoutEmail.Failed': 'Could not start checkout. Please try again.',
    'CheckoutEmail.Heading': 'What email should this purchase belong to?',
    'CheckoutEmail.SignInBody': 'There is already a VoiceDojo account under {Email}. Sign in and buy from there, so this purchase lands on the account you already have.',
    'CheckoutEmail.SignInCta': 'Sign in',
    'CheckoutEmail.SignInHeading': 'You already have an account',
    'CheckoutEmail.SignInUseAnother': 'Use a different email',
    'CheckoutEmail.Working': 'Starting checkout…',
    'CreditLedger.AllowanceDebtRepaid': '{Debt} repaid from this month\'s allowance',
    'CreditLedger.AllowanceLapsed': '{Lapsed} left from the previous allowance lapsed',
    'CreditLedger.ColumnAmount': 'Amount',
    'CreditLedger.ColumnBalance': 'Balance',
    'CreditLedger.ColumnDate': 'Date',
    'CreditLedger.ColumnType': 'Type',
    'CreditLedger.EventsEmpty': 'No credit events yet.',
    'CreditLedger.Heading': 'Credit history',
    'CreditLedger.Lede': 'Every purchase, grant, charge and refund on your AI credits, newest first.',
    'CreditLedger.LiveMinutes': '{Minutes} min',
    'CreditLedger.LoadFailed': 'Could not load your credit history.',
    'CreditLedger.Loading': 'Loading your credit history…',
    'CreditLedger.MonthlyAllowance': 'Monthly allowance → {Allowance}',
    'CreditLedger.Pack': '{Pack} pack ({Credits} credits)',
    'CreditLedger.PackRefund': 'Pack refunded · {Pack}',
    'CreditLedger.Refund': 'Refund',
    'CreditLedger.RefundedInFull': 'refunded in full',
    'CreditLedger.Settled': 'reserved {Reserved}, refunded {Refunded}',
    'CreditLedger.Settling': 'reserved {Reserved}, settling…',
    'CreditLedger.ShowMore': 'Show more',
    'CreditLedger.SourceActiveListening': 'Active Listening',
    'CreditLedger.SourceAiReview': 'AI Review',
    'CreditLedger.SourceDeliveryPlan': 'Delivery plan',
    'CreditLedger.SourceLiveConvo': 'Live convo',
    'CreditLedger.SourceLivePitch': 'Live pitch',
    'CreditLedger.SourceRehearsalPdfRecognition': 'Rehearsal PDF import',
    'CreditLedger.SourceRehearsalPlan': 'Rehearsal plan',
    'CreditLedger.SourceRewrite': 'Rewrite for speaking',
    'CreditLedger.TakeUnsaved': 'take not saved',
    'CreditLedger.TimesIn': 'Times in {Zone}',
    'CreditLedger.TypeAdminAdjust': 'Admin adjust',
    'CreditLedger.TypeSignupBonus': 'Sign-up bonus',
    'CreditLedger.TypeSupportAdjust': 'Adjustment by VoiceDojo support',
    'CreditReceipt.ChargedMany': 'Charged {Charged} credits · you have {Balance}',
    'CreditReceipt.ChargedOne': 'Charged {Charged} credit · you have {Balance}',
    'CreditReceipt.HistoryLink': 'Credit history',
    'CreditReceipt.LiveMany': '{Minutes} min · {Charged} credits · you have {Balance}',
    'CreditReceipt.LiveOne': '{Minutes} min · {Charged} credit · you have {Balance}',
    'CreditReceipt.SettledMany': 'Charged {Charged} credits ({Reserved} reserved, {Refunded} refunded) · you have {Balance}',
    'CreditReceipt.SettledOne': 'Charged {Charged} credit ({Reserved} reserved, {Refunded} refunded) · you have {Balance}',
    'Culture.English': 'English',
    'Culture.EnglishShort': 'EN',
    'Culture.ToggleAria': 'Change language',
    'Culture.Vietnamese': 'Tiếng Việt',
    'Culture.VietnameseShort': 'VI',
    'DataExport.Copied': 'Links copied.',
    'DataExport.CopyAll': 'Copy all links',
    'DataExport.DownloadAll': 'Download all',
    'DataExport.Expired': 'This download link has expired. The files have been deleted.',
    'DataExport.Failed': 'We could not load your files. Please try again.',
    'DataExport.FilesHeading': 'Files',
    'DataExport.Heading': 'Download your data',
    'DataExport.Intro': 'Your account is deleted. These files stay available until {Date}; after that they are deleted permanently.',
    'DataExport.Loading': 'Loading your files…',
    'DataExport.ManagerTip': 'There can be many large recordings, so we recommend a download manager: copy all links and paste them into it.',
    'DataExport.NotFound': 'This download link is not valid.',
    'DataExport.Title': 'Download your data · VoiceDojo',
    'EditableName.Cancel': 'Cancel',
    'EditableName.Confirm': 'Rename',
    'EditableName.DialogHeading': 'Rename this take',
    'EditableName.DismissAria': 'Close without renaming',
    'EditableName.EditAria': 'Edit session name',
    'EditableName.ErrorEmpty': 'Name cannot be empty.',
    'EditableName.ErrorFailed': 'Could not rename ({Status}).',
    'EditableName.ErrorNetwork': 'Network error — name reverted.',
    'EditableName.NameLabel': 'Name',
    'EditableName.RenameTitle': 'Click to rename',
    'EditableName.Saved': 'Saved',
    'EditableName.Saving': 'Saving…',
    'EditableName.Untitled': 'Untitled session',
    'Errors.Unexpected': 'Something went wrong. Please try again.',
    'Focus.CueHistoryAria': 'Cue history',
    'Focus.EndCancel': 'Cancel',
    'Focus.EndConfirm': 'End',
    'Focus.EndConfirmTitle': 'Are you sure you want to end your session?',
    'Focus.EndSessionAria': 'End session',
    'Focus.ExitAria': 'Exit',
    'Focus.ExitConfirmBodyCredit': 'The AI credit spent generating this practice will be forfeited — nothing is refunded.',
    'Focus.ExitConfirmBodyQuota': 'The daily practice session spent generating this practice will be forfeited — nothing is refunded.',
    'Focus.ExitConfirmForfeitCredit': 'Yes, and forfeit the credit',
    'Focus.ExitConfirmForfeitQuota': 'Yes, and forfeit the practice session',
    'Focus.ExitConfirmNo': 'No',
    'Focus.ExitConfirmTitle': 'Are you sure you want to cancel the practice session?',
    'Focus.FallbackTitle': 'Practice session',
    'Focus.KeyboardShortcut': 'Keyboard shortcut: {Key}',
    'Focus.Pause': 'Pause',
    'Focus.PausedWhileAway': 'Paused while you were away. Press Resume or Space to carry on.',
    'Focus.Resume': 'Resume',
    'Focus.SessionTitle': '{Practice} · {Name}',
    'Focus.StartLabel': 'Record',
    'Focus.TimeOfPlanned': '{Elapsed} / {Planned}',
    'Footer.About': 'About',
    'Footer.Copyright': '© VoiceDojo',
    'Footer.LegalAria': 'Legal and pricing',
    'Footer.Pricing': 'Pricing',
    'Footer.Privacy': 'Privacy Policy',
    'Footer.Support': 'Support',
    'Footer.SupportEmail': 'support@voicedojo.ai',
    'Footer.Terms': 'Terms of Service',
    'Footer.ThirdParty': 'Third-party notices',
    'HomeMove.Banner': 'Moving your account to {Region} — you can keep recording. Saving and AI features return in a few minutes.',
    'HomeMove.BannerUnknownRegion': 'Moving your account to another region — you can keep recording. Saving and AI features return in a few minutes.',
    'HomeMove.Region.Au': 'Australia',
    'HomeMove.Region.Na': 'North America',
    'HomeMove.Region.Sg': 'Singapore',
    'Impersonation.ActingAs': 'Acting as {Name}',
    'Impersonation.ActingAsDetail': 'Acting as {Name} · {Email}',
    'Impersonation.ActionUnavailable': 'Unavailable while impersonating',
    'Impersonation.Badge': 'Impersonating',
    'Impersonation.FailedToStop': 'Failed to stop impersonation.',
    'Impersonation.IdentityAria': 'Impersonation session',
    'Impersonation.Reason': 'Reason: {Reason}',
    'Impersonation.SignedInAs': 'Signed in as {Email}',
    'Impersonation.StopAria': 'Stop impersonating',
    'Impersonation.StopIdle': 'Stop impersonating',
    'Impersonation.StopStopping': 'Stopping…',
    'Layout.AboutLabel': 'About VoiceDojo',
    'Layout.Offline': '**Offline** — the server isn’t reachable. You can still practise with random cues; AI content/review, music, history and login are unavailable.',
    'LearningStage.ConsciousCompetence': 'Conscious competence',
    'LearningStage.ConsciousIncompetence': 'Conscious incompetence',
    'LearningStage.UnconsciousCompetence': 'Unconscious competence',
    'LearningStage.UnconsciousIncompetence': 'Unconscious incompetence',
    'LocalCache.FallbackTakeName': '{Practice} take',
    'LocalCache.ListFailed': 'Could not read the takes stored on this device.',
    'LocalCache.SaveFailed': 'This take could not be kept on this device — it will be gone when you reload. Download it or save it to your library now.',
    'LocalCache.StorageFull': 'Your browser storage is full, so this take was not kept on this device — it will be gone when you reload. Download it or save it to your library now.',
    'MicLevel.MeterAria': 'Microphone input level',
    'MicLevel.QuietHint': 'Your mic sounds very quiet. Try speaking at your normal volume, moving closer to the mic, or picking a different microphone before you record.',
    'NameDialog.DismissAria': 'Dismiss',
    'NameDialog.Heading': 'Welcome to VoiceDojo. What should we call you?',
    'NameDialog.NameLabel': 'Name',
    'NameDialog.NamePlaceholder': 'Your name',
    'NameDialog.Save': 'Save',
    'NameDialog.SaveAria': 'Save name',
    'NameDialog.Saving': 'Saving…',
    'Nav.Account': 'Account',
    'Nav.ActiveListening': 'Active Listening',
    'Nav.Archetype': 'Archetype',
    'Nav.BodyLanguage': 'Body Language',
    'Nav.CloseNav': 'Close navigation',
    'Nav.Instrument': 'The Instrument',
    'Nav.Library': 'My library',
    'Nav.Mastery': 'Mastery',
    'Nav.MasteryLockTooltip': 'Please sign up!',
    'Nav.OpenNav': 'Open navigation',
    'Nav.Playground': 'Playground',
    'Nav.PracticeNavAria': 'Practice navigation',
    'Nav.PremiumLockTooltip': 'Premium only',
    'Nav.Progress': 'Progress',
    'Nav.RecordReview': 'Rehearsal',
    'Nav.Riff': 'Riff',
    'Nav.Storytelling': 'Storytelling',
    'Nav.Wordmark': 'VoiceDojo',
    'NewVersion.Body': 'A new webapp version has been released. Please refresh your browser.',
    'NewVersion.Later': 'Cancel - I\'ll refresh later',
    'NewVersion.Refresh': 'Refresh',
    'NewVersion.Title': 'New version available',
    'Offline.AccuracyNote': 'AI-generated practice content can be inaccurate — use it to practise, not as fact.',
    'Offline.Advanced': 'Advanced',
    'Offline.AdvancedHint': 'Picking a model downloads it once and caches it in your browser; a topic applies to your next take only.',
    'Offline.BuiltWithLlama': 'Built with Llama',
    'Offline.CatalogUnavailable': 'the list of on-device models could not be fetched and this device holds no saved copy; check your connection',
    'Offline.Incoherent': 'The on-device model returned words strung together rather than sentences — only {Percent}% of it is everyday connecting words. Try again, or pick a larger model under Advanced.',
    'Offline.LicencesLink': 'Model licences',
    'Offline.LoadFailed': 'The model could not be loaded: {Error}. Re-toggle Offline mode or pick another model.',
    'Offline.ModelLabel': 'Model',
    'Offline.OfferAccept': 'Yes — turn on offline AI',
    'Offline.OfferBody': 'This device can run VoiceDojo’s AI itself: offline mode keeps practice content generation local, after a one-time download of about {SizeMb} MB. You can turn it off any time from the Offline mode switch.',
    'Offline.OfferDecline': 'Not now',
    'Offline.OfferPrivacy': 'Offline AI runs right in your browser. What it generates, and your takes, stay on this device. [Learn more](/privacy#third-party-processors)',
    'Offline.OfferTitle': 'Run the AI on this device?',
    'Offline.Recommended': 'recommended',
    'Offline.Repetitive': 'The on-device model repeated itself — only {Percent}% of the piece is new writing. Try again, or pick a larger model under Advanced.',
    'Offline.ShowAll': 'Show all',
    'Offline.StateDownloading': 'downloading',
    'Offline.StateLoading': 'loading',
    'Offline.StateReady': 'ready',
    'Offline.Subtitle': 'Runs in your browser · no quota',
    'Offline.TierLarge': 'Large (needs a strong GPU)',
    'Offline.TierMedium': 'Medium',
    'Offline.TierSmall': 'Small',
    'Offline.TierTiny': 'Tiny',
    'Offline.Title': 'Offline mode',
    'Offline.ToggleAria': 'Offline mode — generate content on-device, uses no daily quota',
    'Offline.TooShort': 'The on-device model returned only {Words} words instead of about {Target}. Try again, or pick a larger model under Advanced.',
    'Offline.WorkerMessageFailed': 'The on-device model\'s worker thread sent something this page could not read. Re-toggle Offline mode to start it again.',
    'Pending.CreditsSettingUp': 'Setting up your AI credits',
    'Pending.CreditsStuck': 'Your AI credits haven\'t been set up yet.',
    'Pending.ParseStuck': 'Reading your PDF is taking too long. Retrying costs nothing extra.',
    'Pending.PlanStuck': 'Building this delivery plan is taking too long. Retrying costs nothing extra.',
    'Pending.PurchaseApplying': 'Applying your purchase',
    'Pending.PurchaseStuck': 'Your purchase hasn\'t been applied yet.',
    'Pending.Retry': 'Retry',
    'Pending.ReviewStuck': 'Your AI Review hasn\'t started yet.',
    'Playback.CoachingCuesCount': 'Coaching cues · {Count}',
    'Playback.CueSeekHint': 'Tap a cue to jump there',
    'Playback.CurrentTime': 'Current time',
    'Playback.Loading': 'Loading recording…',
    'Playback.Pause': 'Pause playback',
    'Playback.Play': 'Play recording',
    'Playback.SeekAria': 'Recording seek',
    'Playback.TotalDuration': 'Total duration',
    'Playback.Unsupported': 'Preview isn\'t supported for this video in your browser — the saved file still plays in your media player.',
    'Playback.VideoAria': 'Recorded video playback',
    'PostTakeReview.AwaitingUpload': 'Saving this take to your library first — AI Review opens as soon as the upload finishes.',
    'PostTakeReview.DiscardConfirmBody': 'It is removed from this device. This cannot be undone.',
    'PostTakeReview.DiscardConfirmTitle': 'Discard this take?',
    'PostTakeReview.DiscardTake': 'Discard take',
    'PostTakeReview.Discarded': 'Discarded from this device — it is gone when you leave this page.',
    'PostTakeReview.DownloadVideo': 'Download video',
    'PostTakeReview.KeepManage': 'Manage',
    'PostTakeReview.MoreActionsAria': 'More actions',
    'PostTakeReview.ReviewGuestReason': 'Your take stays on this device — we\'ll bring you straight back to it.',
    'PostTakeReview.ReviewNoCredits': 'You\'re out of AI credits.',
    'PostTakeReview.ReviewSignIn': 'Sign in to review',
    'PostTakeReview.SeriesLocalOnly': 'This take is on this device. It joins your series when you save it or request an AI Review.',
    'PostTakeReview.StripCreateAccount': 'Create an account',
    'PostTakeReview.StripLocalSub': 'It stays on this device for {Days} days, then it is gone.',
    'PostTakeReview.StripSavedSub': 'Kept automatically.',
    'PostTakeReview.StripSavedTitle': 'Saved to your library',
    'PostTakeReview.StripSavingSub': 'Automatic — your setting keeps every take.',
    'PostTakeReview.StripSavingTitle': 'Saving to your library',
    'PostTakeReview.StripSeePremium': 'See Premium',
    'PostTakeReview.TakeComplete': 'Take complete',
    'PracticeLabel.ActiveListening': 'Active Listening',
    'PracticeLabel.ArchetypePlay': 'Archetype',
    'PracticeLabel.BodyLanguagePlay': 'Body Language',
    'PracticeLabel.RecordAndReview': 'Rehearsal',
    'PracticeLabel.Riff': 'Riff',
    'PracticeLabel.Standalone': 'Standalone upload',
    'PracticeLabel.Storytelling': 'Storytelling',
    'PracticeLabel.TheInstrument': 'The Instrument',
    'PracticeView.AiGuide': 'AI guide',
    'PracticeView.ContentError': 'The AI guide could not write your story. You can still record — read anything you like aloud and play with the keys.',
    'PracticeView.ContentLoading': 'The AI is writing you a short piece to read…',
    'PracticeView.CueLiveNow': 'cue live now',
    'PracticeView.CuesSoFar': 'Cues so far',
    'PracticeView.KindToReadAloud': '{Kind} to read aloud',
    'PracticeView.ReadAloud': 'read aloud',
    'PracticeView.TokenCount': '{Count} words',
    'Pricing.BuyPack': 'Buy {Pack}',
    'Pricing.Capacity': '**Premium is currently at capacity.** Join the waitlist — we\'ll email you when a spot opens.',
    'Pricing.Costs': 'AI Review from {ReviewFrom} credit (dialable — model, Effort + frame rate) · Active Listening {ActiveListening} credit · Live conversation from {LiveConvo} credits/min',
    'Pricing.DemoFreeUnavailable': 'Your browser can\'t speak cues.',
    'Pricing.DemoFreeVoice': 'Free voice',
    'Pricing.DemoLede': 'Live cues are spoken aloud. The Premium voice demonstrates each instruction — "Louder" is said louder. The free browser voice just reads the words. Same phrase, different delivery:',
    'Pricing.DemoLoading': 'Loading…',
    'Pricing.DemoPremiumUnavailable': 'Sample unavailable right now.',
    'Pricing.DemoPremiumVoice': 'Premium voice',
    'Pricing.DemoTitle': 'Hear the difference',
    'Pricing.FirstFreeCredits': '**First {SignupBonus} credits are on us.** Every new account gets {SignupBonus} free AI credits on signup — enough to sample every AI capability. No card required.',
    'Pricing.Footnote': 'Questions about billing? See your [billing dashboard](/billing) or review the [Terms](/terms) and [Privacy Policy](/privacy).',
    'Pricing.FreeCta': 'Start recording',
    'Pricing.FreeFeatureDownload': 'Download your recordings',
    'Pricing.FreeFeatureNoServerStorage': 'No server-side storage',
    'Pricing.FreeFeatureRecordLocally': 'Record locally in the browser',
    'Pricing.FreeFeatureSignupBonus': '{SignupBonus} signup-bonus AI credits',
    'Pricing.FreePrice': '$0',
    'Pricing.FreeTitle': 'Free',
    'Pricing.Lede': 'One AI credit currency. Pay as you go, or subscribe for the monthly allowance.',
    'Pricing.LegalAgree': 'By purchasing you agree to the [Terms](/terms) and [Privacy Policy](/privacy).',
    'Pricing.Loading': 'Loading',
    'Pricing.MsgAlreadySubscribed': 'You already have an active subscription.',
    'Pricing.MsgCheckoutFailed': 'Could not start checkout. Please try again.',
    'Pricing.MsgEnterEmail': 'Please enter your email.',
    'Pricing.MsgFreeDemoUnavailable': 'Your browser does not support spoken cues.',
    'Pricing.MsgPremiumDemoUnavailable': 'The Premium voice sample is unavailable right now.',
    'Pricing.MsgSignInToBuy': 'Please sign in to purchase credits.',
    'Pricing.MsgSignInToSubscribe': 'Please sign in to subscribe.',
    'Pricing.MsgStartingCheckout': 'Starting checkout…',
    'Pricing.MsgStartingSubscription': 'Starting subscription…',
    'Pricing.MsgUnknownProduct': 'Unknown product. Please refresh the page and try again.',
    'Pricing.MsgWaitlistAdmitted': 'You\'ve already been admitted — finish your subscription below.',
    'Pricing.MsgWaitlistFailed': 'Could not join the waitlist. Please try again.',
    'Pricing.MsgWaitlistPosition': 'You\'re #{Position} on the waitlist. We\'ll email you when a slot opens.',
    'Pricing.MsgWaitlistSlotOpen': 'A Premium spot is open for you. We\'ve sent you an email with a checkout link.',
    'Pricing.PackSavingPerCredit': 'Save {Percent}% per credit',
    'Pricing.PackSavingPerGb': 'Save {Percent}% per GB',
    'Pricing.PacksFeatureNeverExpire': 'Credits never expire',
    'Pricing.PacksFeatureRetention': 'Reviewed takes kept {Days} days after the review',
    'Pricing.PacksFeatureSpend': 'Spend credits across every AI capability',
    'Pricing.PacksPrice': 'Pay as you go',
    'Pricing.PacksTitle': 'AI credit packs',
    'Pricing.PremiumCurrentPlan': 'Your current plan',
    'Pricing.PremiumFeatureCredits': '{Credits} AI credits included each month',
    'Pricing.PremiumFeatureOverage': 'Overage via paid credit packs at the same rates',
    'Pricing.PremiumFeatureRetention': 'You choose how long recordings are kept',
    'Pricing.PremiumFeatureStorage': '100 GB of recording storage included',
    'Pricing.PremiumManageLink': 'Manage your subscription',
    'Pricing.PremiumPrice': '${Price} / month',
    'Pricing.PremiumTitle': 'Premium',
    'Pricing.Redirecting': 'Redirecting…',
    'Pricing.StartSubscription': 'Start subscription',
    'Pricing.TabTitle': 'Pricing · VoiceDojo',
    'Pricing.TiersAria': 'Pricing tiers',
    'Pricing.Title': 'Pricing',
    'Pricing.WaitlistEmailLabel': 'Your email address',
    'Pricing.WaitlistEmailPlaceholder': 'you@example.com',
    'Pricing.WaitlistFormAria': 'Join the Premium waitlist',
    'Pricing.WaitlistJoin': 'Join the waitlist',
    'Pricing.WaitlistJoining': 'Joining…',
    'Profile.AiCreditsLabel': 'AI credits',
    'Profile.AiCreditsSuffix': 'AI credits',
    'Profile.AppVersion': 'App version',
    'Profile.AvatarLabel': 'Avatar',
    'Profile.AvatarSectionAria': 'Your avatar',
    'Profile.AvatarUpload': 'Upload a photo',
    'Profile.AvatarUploading': 'Uploading…',
    'Profile.Cancel': 'Cancel',
    'Profile.ConfirmCopy': 'This cannot be undone. Type your email **{Email}** to confirm.',
    'Profile.ConfirmEmailLabel': 'Confirm your email',
    'Profile.Contact': 'Questions? Email [{Email}](mailto:{Email}).',
    'Profile.CreditsSectionAria': 'Your credits',
    'Profile.DangerCopy': 'Deleting your account is **immediate and permanent**. Your access ends at once, and we then erase your recordings, reviews, and account, and cancel any active subscription. **There is no way to recover them.**',
    'Profile.DangerLabel': 'Danger zone',
    'Profile.DangerPremiumExport': 'As a Premium member, you will get an email with a private link to download your recordings and data. It works for 7 days; after that everything is deleted.',
    'Profile.DangerSectionAria': 'Delete account',
    'Profile.DeleteMyAccount': 'Delete my account',
    'Profile.Deleting': 'Deleting…',
    'Profile.Heading': 'Profile',
    'Profile.HelpLabel': 'Help & contact',
    'Profile.HelpSectionAria': 'Help and contact',
    'Profile.IncludedThisMonth': '· {Count} included this month',
    'Profile.ManageSubscription': 'Manage subscription',
    'Profile.NameLabel': 'Name',
    'Profile.NamePlaceholder': 'Your name',
    'Profile.NameSectionAria': 'Your name',
    'Profile.PermanentlyDelete': 'Permanently delete',
    'Profile.PermanentlyDeleteAria': 'Permanently delete my account',
    'Profile.PracticesLeftToday': '{Remaining} of {Limit} practices left today',
    'Profile.PricingLink': 'Pricing & credit packs',
    'Profile.PrivacyLink': 'Privacy Policy',
    'Profile.Save': 'Save',
    'Profile.SaveAria': 'Save profile',
    'Profile.Saved': 'Saved.',
    'Profile.Saving': 'Saving…',
    'Profile.StorageSectionAria': 'Your cloud recording storage',
    'Profile.TermsLink': 'Terms of Service',
    'Profile.TimeZoneCurrentTime': 'Current time: {Time}',
    'Profile.TimeZoneLabel': 'Timezone',
    'Profile.TimeZoneRegionAfrica': 'Africa',
    'Profile.TimeZoneRegionAmerica': 'Americas',
    'Profile.TimeZoneRegionAntarctica': 'Antarctica',
    'Profile.TimeZoneRegionArctic': 'Arctic',
    'Profile.TimeZoneRegionAsia': 'Asia',
    'Profile.TimeZoneRegionAtlantic': 'Atlantic',
    'Profile.TimeZoneRegionAustralia': 'Australia',
    'Profile.TimeZoneRegionEurope': 'Europe',
    'Profile.TimeZoneRegionIndian': 'Indian Ocean',
    'Profile.TimeZoneRegionOther': 'Other',
    'Profile.TimeZoneRegionPacific': 'Pacific',
    'Profile.TimeZoneSectionAria': 'Your timezone',
    'Profile.TimeZoneUseDevice': 'Use my device\'s timezone ({Zone})',
    'Profile.Title': 'Profile · VoiceDojo',
    'Profile.TopUpCredits': 'Top up credits',
    'Profile.WpmHint': 'Sizes generated practice content to your take length, and sets the pace the script highlight walks at.',
    'Profile.WpmLabel': 'Preferred speaking rate',
    'Profile.WpmNumberAria': 'Preferred words per minute',
    'Profile.WpmSectionAria': 'Preferred speaking rate',
    'Profile.WpmSuffix': 'words per minute',
    'Recording.CueVoiceVolume': 'Cue voice volume',
    'Recording.CuesOff': 'Cues off',
    'Recording.CuesOn': 'Cues on',
    'Recording.DownloadPracticeText': 'Download practice text',
    'Recording.LivePreviewAria': 'Live camera preview',
    'Recording.MusicOff': 'Music off',
    'Recording.MusicOn': 'Music on',
    'Recording.MusicStatusArchetype': 'Background music playing for {Archetype} at intensity {Intensity}.',
    'Recording.MusicStatusMood': 'Background music playing for {Mood} mood at intensity {Intensity}.',
    'Recording.MusicStatusMuted': 'Background music muted.',
    'Recording.MusicStatusPaused': 'Background music paused.',
    'Recording.MusicVolume': 'Music volume',
    'Recording.PacerAria': 'Script pacer — a metronome that walks the script at the take’s own pace',
    'Recording.PacerOff': 'Pacer off',
    'Recording.PacerOn': 'Pacer on',
    'Recording.PacerUnavailable': 'Pacer unavailable',
    'Recording.PacerUnavailableAria': 'Script pacer unavailable — this stand-in script is not sized to your take, so there is no pace to walk',
    'Recording.RecordAgain': 'Record again',
    'Recording.RecoveryIllustrationAria': 'Browser address bar with the site-info (i) icon highlighted',
    'Recording.RecoverySteps': 'To re-grant access, click the site-info **(i)** icon beside your browser’s address bar and allow camera & microphone, then try again.',
    'Recording.RerecordCancel': 'Cancel',
    'Recording.RerecordConfirm': 'Delete and re-record',
    'Recording.RerecordConfirmTitle': 'Are you sure you want to record again. This will delete your current recording.',
    'Recording.StatusStartingCamera': 'Starting camera…',
    'Recording.TryAgain': 'Try again',
    'RecordingElsewhere.Body': 'You\'re recording {Practice} in another tab or window. Please return to it to finish your take.',
    'RecordingElsewhere.CloseBlockedAck': 'Got it',
    'RecordingElsewhere.CloseBlockedHint': 'Your browser won\'t close this tab automatically — press {Shortcut} to close it.',
    'RecordingElsewhere.DismissAria': 'Dismiss',
    'RecordingElsewhere.Heading': 'You\'re recording in another tab',
    'RecordingElsewhere.Ok': 'Close this tab',
    'RecordingElsewhere.OkAria': 'Close this tab',
    'RecordingElsewhere.PracticeFallback': 'a practice',
    'RecordingElsewhere.StopStartAria': 'Stop that recording and continue here',
    'RecordingElsewhere.StopStartIdle': 'Stop that recording and continue here',
    'RecordingElsewhere.StopStartStopping': 'Stopping…',
    'RecordingSettings.AutoDeleteHint': 'Deletes takes saved to your account after the number of days you choose. Takes kept only on this device clear on their own after {Days} days.',
    'RecordingSettings.AutoDeleteLabel': 'Auto-delete old takes',
    'RecordingSettings.AutoSaveHint': 'Automatically save every completed take to your library (uses storage). On by default for Premium — turn it off to keep takes on this device until you save them.',
    'RecordingSettings.AutoSaveLabel': 'Auto Save takes',
    'RecordingSettings.CueLengthHint': 'How long a cue\'s effect stays on the script, so you have time to follow it. A longer cue message always gets its full time.',
    'RecordingSettings.CueLengthLabel': 'Cue length',
    'RecordingSettings.CueLengthLong': 'Long · {Seconds} s',
    'RecordingSettings.CueLengthNormal': 'Normal · {Seconds} s',
    'RecordingSettings.CueLengthShort': 'Short · {Seconds} s',
    'RecordingSettings.DefaultQualityHint': 'New takes start at this quality. Higher quality uses more storage. You can still change it before each take.',
    'RecordingSettings.DefaultQualityLabel': 'Default recording quality',
    'RecordingSettings.Heading': 'Recording settings',
    'RecordingSettings.KeepDaysAria': 'Days to keep saved takes',
    'RecordingSettings.KeepDaysLabel': 'Keep saved takes for',
    'RecordingSettings.KeepDaysOutOfRange': 'Saved takes can be kept for {Min} to {Max} days. This will settle at {Settled}.',
    'RecordingSettings.KeepDaysUnit': 'days',
    'RecordingSettings.Lede': 'Control whether your takes are saved to the cloud and the quality new takes record at.',
    'RecordingSettings.LedeWithoutStorage': 'Choose the quality new takes record at and your preferred speaking rate.',
    'RecordingSettings.PracticeRemindersHint': 'If your 12-week plan falls behind and you go quiet, we email you at most once a week. They stop after two go unanswered, until you practise again.',
    'RecordingSettings.PracticeRemindersLabel': 'Practice reminders',
    'RecordingSettings.Save': 'Save settings',
    'RecordingSettings.Saved': 'Recording settings saved.',
    'RecordingSettings.Saving': 'Saving…',
    'RecordingSettings.SectionAria': 'Recording settings',
    'RecordingSetup.BlurDisabledByPick': 'Blur supports up to {Cap}, so it’s off for this resolution.',
    'RecordingSetup.BlurLimitsQuality': 'Blur is on — recording is limited to {Cap}.',
    'RecordingSetup.BlurOff': 'Blur off',
    'RecordingSetup.BlurOn': 'Blur on',
    'RecordingSetup.BlurUnavailable': 'Background blur isn’t available right now, so this take is recording without it.',
    'RecordingSetup.Camera': 'Camera',
    'RecordingSetup.CameraFallback': 'Camera {Index}',
    'RecordingSetup.Microphone': 'Microphone',
    'RecordingSetup.MicrophoneFallback': 'Microphone {Index}',
    'RecordingSetup.NoiseReductionLocked': 'Remove background noise is locked while recording.',
    'RecordingSetup.NoiseReductionOff': 'Noise removal off',
    'RecordingSetup.NoiseReductionOffNotice': 'Noise removal is off — music, spoken cues and room noise may be captured.',
    'RecordingSetup.NoiseReductionOn': 'Noise removal on',
    'RecordingSetup.PermissionDenied': 'Camera and microphone access is off, so device selection isn’t available. Allow access in your browser to pick a camera or mic and see a preview.',
    'RecordingSetup.PreviewFailed': 'Could not start the camera preview.',
    'RecordingSetup.VideoQualityCycleAria': 'Video quality {Current}. Select to change to {Next}.',
    'RecordingSetup.VideoQualityLocked': 'Video quality is locked while recording.',
    'ReviewPack.Download': 'Download review pack',
    'ReviewPack.ErrorForbidden': 'You don\'t have access to this recording.',
    'ReviewPack.ErrorGeneric': 'Download failed. Please try again.',
    'ReviewPack.ErrorGone': 'Recording is no longer available for download.',
    'ReviewPack.ErrorPending': 'Review still pending — try again in a moment.',
    'ReviewPack.ErrorSignIn': 'Please sign in and try again.',
    'ReviewPack.ErrorUnavailable': 'Download service is temporarily unavailable. Please try again.',
    'ReviewPack.Pending': 'Review still pending',
    'ReviewPack.PreparingPack': 'Preparing your review pack…',
    'ReviewPack.Saved': 'Saved to your Downloads folder.',
    'SaveToLibrary.AddStorage': 'Add storage',
    'SaveToLibrary.AutoUploadFailed': 'Auto-upload failed — this take stayed on your device.',
    'SaveToLibrary.BackgroundSaved': 'Take saved',
    'SaveToLibrary.BackgroundSaving': 'Saving take…',
    'SaveToLibrary.BackgroundSavingPercent': 'Saving take… {Percent}%',
    'SaveToLibrary.DismissAria': 'Dismiss',
    'SaveToLibrary.Failed': 'Could not save this take. Please try again.',
    'SaveToLibrary.Heading': 'Keep this take',
    'SaveToLibrary.ManageStorage': 'Manage storage',
    'SaveToLibrary.NotAvailable': 'Saving to your library isn’t available on your current plan.',
    'SaveToLibrary.Nudge': 'Save your takes to keep them',
    'SaveToLibrary.OutOfStorage': 'You\'re out of storage, so this take stayed on your device — it\'s kept here for {Days} days, then it\'s gone. Add storage or clean up some takes, then save it again.',
    'SaveToLibrary.OverLimit': 'You\'re over your storage limit — add storage, or clean up some of your takes.',
    'SaveToLibrary.PrePracticeWarning': 'You\'re out of storage. Practise anyway and this take won\'t be saved to your library or kept for your mastery week, and saving it by hand will be refused too — the practice itself still counts. It stays on this device for {Days} days.',
    'SaveToLibrary.PrePracticeWarningManual': 'You\'re out of storage. Practise anyway and saving this take to your library will be refused — the practice itself still counts. It stays on this device for {Days} days.',
    'SaveToLibrary.Retry': 'Retry',
    'SaveToLibrary.Save': 'Save to my library',
    'SaveToLibrary.Saving': 'Saving…',
    'SaveToLibrary.ShowInLibraryAria': '{Status} — show this take in My library',
    'SaveToLibrary.UploadingAria': 'Saving this take to your library',
    'SaveToLibrary.UpsellSave': 'Save to Library 🔒',
    'Search.Clear': 'Clear search',
    'Search.Label': 'Search this list',
    'Search.NoMatch': 'Nothing matches “{Query}”.',
    'Search.NoMatchFiltered': 'Nothing matches “{Query}” with the filters you have on.',
    'Search.Placeholder': 'Type to filter…',
    'Search.ResultsMany': '{Count} results',
    'Search.ResultsOne': '{Count} result',
    'SelfReview.Auditory': 'Auditory check',
    'SelfReview.AuditoryShort': 'Auditory',
    'SelfReview.CheckDoneAria': '{Check}: done',
    'SelfReview.CheckNotDoneAria': '{Check}: not done',
    'SelfReview.ChecksAria': 'Self-review checks',
    'SelfReview.Done': 'Done',
    'SelfReview.ModesAria': 'Playback mode',
    'SelfReview.NormalPlayback': 'Normal playback',
    'SelfReview.Saving': 'Saving the check',
    'SelfReview.Transcript': 'Transcript check',
    'SelfReview.TranscriptShort': 'Transcript',
    'SelfReview.Visual': 'Visual check',
    'SelfReview.VisualShort': 'Visual',
    'SessionDetail.Back': 'Back',
    'SessionDetail.BackAria': 'Back to previous page',
    'SessionDetail.FailedToLoad': 'Failed to load the session.',
    'SessionDetail.SessionNotFound': 'Session not found.',
    'SessionDetail.TabDefault': 'Practice session · VoiceDojo',
    'SessionDetail.TabRecording': '{Name} · Recording · VoiceDojo',
    'SessionDetail.Untitled': 'Untitled',
    'SessionPanel.AwaitingHint': 'Setup confirmed — preparing your session…',
    'SessionPanel.CannotEnd': 'Could not end session ({Status}).',
    'SessionPanel.ConfirmEnd': 'End session early?',
    'SessionPanel.ConfirmLeave': 'You\'re recording — leave and stop the take?',
    'SessionPanel.DurationLabel': 'Duration',
    'SessionPanel.EndSession': 'End session',
    'SessionPanel.EndSessionAria': 'End session',
    'SessionPanel.EndSessionEnding': 'Ending…',
    'SessionPanel.NetworkError': 'Network error. Please try again.',
    'SessionPanel.NewSession': 'New session',
    'SessionPanel.PersonaliseAriaLabel': 'Personalise coaching prompts',
    'SessionPanel.PersonaliseFieldLabel': 'What\'s this practice for?',
    'SessionPanel.PersonaliseLabel': 'Personalise (optional)',
    'SessionPanel.PersonalisePlaceholder': 'e.g. pitching to investors',
    'SessionPanel.QuotaExhaustedGuest': 'Daily practice limit reached.',
    'SessionPanel.QuotaExhaustedLimit': 'Daily practice limit reached — try again tomorrow.',
    'SessionPanel.QuotaRemaining': '{Remaining} of {Limit} practice {Sessions} left today.',
    'SessionPanel.QuotaRemainingManySessions': 'sessions',
    'SessionPanel.QuotaRemainingOneSession': 'session',
    'SessionPanel.ResumeSession': 'Resume session',
    'SessionPanel.ResumeSessionAria': 'Resume session',
    'SessionPanel.SessionDurationAria': 'Session duration in minutes',
    'SessionPanel.StartNewSessionAria': 'Start a new session',
    'SessionPanel.StartSession': 'Start session',
    'SessionPanel.StartSessionAria': 'Start session',
    'SessionPanel.StartSessionStarting': 'Starting…',
    'SessionPanel.StillLoading': 'Still loading — please try again in a moment.',
    'SessionPanel.TimeElapsed': 'Time elapsed: {Time}',
    'SessionPanel.TimerAria': 'Time remaining',
    'SignUpCta.GuestClaimReason': 'Create your account to save your progress — your practice carries over. Sign-up is quick and password-free.',
    'SignUpCta.GuestPracticeReason': 'This practice needs an account. Create yours to unlock it — sign-up is quick and password-free.',
    'SignUpCta.GuestPrimary': 'Save your progress',
    'SignUpCta.GuestReason': 'Create your account to unlock AI Review on this take — and save your progress. Your sessions and practice carry over.',
    'SignUpCta.GuestSecondary': 'Been here before?',
    'SignUpCta.GuestUploadReason': 'Uploading a recording for AI Review needs an account. Create yours to get started — sign-up is quick and password-free.',
    'SignUpCta.NeedAccountPrimary': 'Sign up for {SignupBonus} free credits',
    'SignUpCta.NeedAccountReason': 'Want an AI Review on your take? You\'ll need an account + credits — new sign-ups get {SignupBonus} free credits.',
    'SignUpCta.NeedAccountSecondary': 'See pricing',
    'SignUpCta.OutOfCreditsPrimary': 'Add credits',
    'SignUpCta.OutOfCreditsReason': 'You\'re out of credits. Add a credit pack or subscribe to Premium to keep practising with AI Review.',
    'SignUpCta.OutOfCreditsSecondary': 'View billing',
    'SignUpCta.PremiumPlansReason': 'Your plan history is part of Progress, a Premium feature — every 12-week plan you have run, with the weeks you completed. Upgrade to unlock it.',
    'SignUpCta.PremiumPracticePrimary': 'Upgrade to Premium',
    'SignUpCta.PremiumProgressReason': 'Progress is a Premium feature — the 12-week mastery plan tracks your reps week by week and keeps each week\'s recordings reviewable. Upgrade to unlock it.',
    'SignUpCta.PremiumRehearsalReason': 'Pitch your talk live to an AI investor, customer or panel. They interrupt, push back, then give spoken feedback. Rehearsal is part of Premium.',
    'SignUpCta.PreviewAria': 'Example of the Premium feature',
    'SignUpCta.PreviewBadge': 'Example data',
    'SignUpCta.PreviewNote': 'The panel behind this card is an example of what Premium shows — not your own figures.',
    'SignUpCta.SectionAria': 'Account required to continue',
    'StandaloneUpload.ChooseDifferent': 'Choose a different file',
    'StandaloneUpload.ErrorContentType': 'Choose a .mov, .mp4 or .webm recording.',
    'StandaloneUpload.ErrorSignIn': 'Please sign in to review a recording.',
    'StandaloneUpload.ErrorSize': 'Recording must be between 1 byte and {MaxSize}.',
    'StandaloneUpload.Reviewing': 'Reviewing **{Name}**.',
    'StandaloneUpload.UploadRecording': 'Upload your recording',
    'StatusPill.PendingReview': 'Pending review',
    'StatusPill.Recording': 'Recording',
    'StatusPill.ReviewFailed': 'Review failed',
    'StatusPill.Reviewed': 'Reviewed',
    'StatusPill.Status': 'Status',
    'Streaming.GenerationFailed': 'Generation failed. Please try again.',
    'Streaming.Preparing': 'Preparing…',
    'Streaming.PreparingCues': 'preparing cues…',
    'Streaming.TryAgain': 'Try again',
    'Streaming.YourWord': 'Your word',
    'Support.CouldNotVerify': 'We couldn’t verify that this request came from a person. If a content blocker is on, allow Google reCAPTCHA on this page and try again, or email us at [{Email}](mailto:{Email}).',
    'Support.DescriptionLabel': 'What happened?',
    'Support.EmailLabel': 'Your email',
    'Support.Failed': 'Your request didn’t go through. Please try again, or email us at [{Email}](mailto:{Email}).',
    'Support.FormAria': 'Support request form',
    'Support.Heading': 'Support',
    'Support.Intro': 'Stuck, found a bug, or have an idea? Tell us below or write to [{Email}](mailto:{Email}).',
    'Support.NameLabel': 'Your name',
    'Support.RateLimited': 'You’ve sent several requests in a short time. Please try again later, or email us at [{Email}](mailto:{Email}).',
    'Support.RecaptchaNotice': 'This site is protected by reCAPTCHA and the Google [Privacy Policy](https://policies.google.com/privacy) and [Terms of Service](https://policies.google.com/terms) apply.',
    'Support.Sent': 'We’ve received it. A confirmation with your ticket number is on its way to {Email}, and our replies come by email.',
    'Support.Submit': 'Send request',
    'Support.Submitting': 'Sending…',
    'Support.SummaryLabel': 'Summary',
    'Support.Title': 'Support · VoiceDojo',
    'Theme.DarkTheme': 'Dark theme',
    'Theme.LightTheme': 'Light theme',
    'Theme.SwitchToDark': 'Switch to dark theme',
    'Theme.SwitchToLight': 'Switch to light theme',
    'Thinking.Articulating': 'Articulating every syllable…',
    'Thinking.ClearingThroat': 'Clearing its throat…',
    'Thinking.DeepBreath': 'Taking a deep breath…',
    'Thinking.FindingPitch': 'Finding the pitch…',
    'Thinking.FindingVoice': 'Finding its voice…',
    'Thinking.Humming': 'Humming a note…',
    'Thinking.Legato': 'Smoothing the legato…',
    'Thinking.LooseningJaw': 'Loosening the jaw…',
    'Thinking.LowerRegister': 'Dropping to a lower register…',
    'Thinking.MarkingScript': 'Marking the script…',
    'Thinking.Mirror': 'Practising in the mirror…',
    'Thinking.Pacing': 'Finding the pace…',
    'Thinking.Pausing': 'Pausing for effect…',
    'Thinking.PowerSphere': 'Finding the Power Sphere…',
    'Thinking.Projecting': 'Projecting to the back row…',
    'Thinking.Siren': 'Doing a siren…',
    'Thinking.Staccato': 'Tapping out the staccato…',
    'Thinking.TongueTwisters': 'Running tongue twisters…',
    'Thinking.WarmWater': 'Sipping warm water…',
    'Thinking.WarmingUp': 'Warming up the voice…',
    'Toast.DismissAria': 'Dismiss notification',
    'Toast.LiveUpdatesBack': 'Live updates are back.',
    'Toast.LiveUpdatesPaused': 'Live updates are paused. The page still works; refresh to see the latest.',
    'Toast.RegionAria': 'Notifications',
    'Transport.Elapsed': 'Elapsed {Time}',
    'Transport.Pause': 'pause',
    'Transport.StatusRecording': 'recording',
    'Transport.Stop': 'stop',
    'UnsubscribeReminders.Confirm': 'Turn off reminders',
    'UnsubscribeReminders.Done': 'Practice reminders are off. You can turn them back on in your profile.',
    'UnsubscribeReminders.Heading': 'Turn off practice reminders?',
    'UnsubscribeReminders.Lede': 'We’ll stop emailing you when your 12-week plan falls behind. You can turn them back on in your profile.',
    'UnsubscribeReminders.MissingLink': 'This unsubscribe link is incomplete. Use the link from the email, or turn reminders off in your profile.',
    'UnsubscribeReminders.Title': 'Practice reminders · VoiceDojo',
    'UnsubscribeReminders.Working': 'Turning off…',
  },
  'vi-VN': {
    'AboutDialog.Api': 'API',
    'AboutDialog.App': 'Ứng dụng',
    'AboutDialog.BuiltApi': 'Bản dựng (API)',
    'AboutDialog.BuiltFe': 'Bản dựng (FE)',
    'AboutDialog.CloseAria': 'Đóng',
    'AboutDialog.DevChannel': 'DEV',
    'AboutDialog.Loading': 'đang tải…',
    'AboutDialog.Title': 'VoiceDojo',
    'AboutDialog.Unavailable': 'không khả dụng ({Error})',
    'Account.AdminConsole': 'Trang quản trị',
    'Account.AiCredits': 'tín dụng AI',
    'Account.BadgeAdmin': 'Quản trị',
    'Account.BadgeGuest': 'Khách',
    'Account.BadgePremium': 'Cao cấp',
    'Account.BalancesAria': 'Số dư của bạn',
    'Account.DailyPracticesLeftAria': 'Lượt luyện còn lại hôm nay',
    'Account.Greeting': 'Chào {Name}',
    'Account.Language': 'Ngôn ngữ',
    'Account.MenuAria': 'Menu tài khoản',
    'Account.PracticesLeftDetail': 'còn {Remaining} trên {Limit} lần luyện tập hôm nay',
    'Account.PracticesLeftMany': 'còn {Remaining} lần luyện tập',
    'Account.PracticesLeftOne': 'còn {Remaining} lần luyện tập',
    'Account.PracticesLeftToday': 'trên {Limit} lượt luyện còn lại hôm nay',
    'Account.Preferences': 'Tùy chọn',
    'Account.Profile': 'Hồ sơ',
    'Account.Reviews': 'Đánh giá AI',
    'Account.SignIn': 'Đăng nhập',
    'Account.SignOut': 'Đăng xuất',
    'Account.SpendableBreakdown': '{Paid} đã mua · {Monthly} hàng tháng',
    'Account.Subscription': 'Gói đăng ký',
    'Account.Theme': 'Giao diện',
    'Account.Version': 'Phiên bản {Version}',
    'ActiveSpine.AutoTrackingDetail': 'Bài luyện hiện tại của bạn được theo dõi tự động — các bản thu trong tuần này được lưu vào cột sống của bạn để xem lại sau.',
    'ActiveSpine.HowTrackedAria': 'Bài luyện của tôi được theo dõi như thế nào?',
    'ActiveSpine.Progress': 'Bạn đã hoàn thành **{Reps}** trong số **{Target}** lần luyện cho cột sống làm chủ tuần này{Element}! Tiếp tục phát huy! 🎯',
    'ActiveSpine.ProgressWithElement': ' ({Element})',
    'Billing.AiCredits': 'Tín dụng AI',
    'Billing.AllowanceResetPending': 'Hạn mức của bạn sẽ làm mới ngay khi kỳ gia hạn ngày {PeriodEnd} hoàn tất.',
    'Billing.AllowanceResets': 'Hạn mức làm mới vào **{Date}**.',
    'Billing.AriaFreePlan': 'Gói miễn phí',
    'Billing.AriaSubscriptionActive': 'Gói đăng ký đang hoạt động',
    'Billing.BuyLedeFree': 'Tín dụng không bao giờ hết hạn — nạp thêm để chạy nhiều Đánh giá AI và Lắng nghe chủ động hơn.',
    'Billing.BuyLedePremium': 'Tín dụng không bao giờ hết hạn và cộng dồn vào hạn mức Cao cấp hằng tháng của bạn.',
    'Billing.BuyMoreCredits': 'Mua thêm tín dụng',
    'Billing.CancelSubscription': 'Hủy gói đăng ký',
    'Billing.Cancelling': 'Đang hủy…',
    'Billing.Costs': 'Chi phí: Đánh giá AI từ {ReviewFrom} tín dụng (tùy chỉnh) · Lắng nghe chủ động {ActiveListening} tín dụng',
    'Billing.CreditsRemaining': 'tín dụng còn lại',
    'Billing.DailyPractice': 'Luyện tập hằng ngày',
    'Billing.EndingArchiveNote': 'Các bản ghi đã lưu sẽ được lưu trữ trong 30 ngày sau đó, rồi bị xoá. Đăng ký lại để giữ chúng.',
    'Billing.EndingOn': 'Gói Cao cấp của bạn kết thúc vào {Date}',
    'Billing.EndingSoon': 'Gói Cao cấp của bạn sắp kết thúc',
    'Billing.FreeBadge': 'Miễn phí',
    'Billing.FreePlan': 'Gói miễn phí',
    'Billing.FreePlanMeta': 'Bạn đang dùng gói miễn phí — luyện tập hằng ngày cùng các hành động AI trả theo tín dụng. Lên Cao cấp để nhận hạn mức tín dụng hằng tháng, {Storage} dung lượng lưu trữ và hơn thế.',
    'Billing.InvoiceStatusAria': 'Hoá đơn {Status}',
    'Billing.KeepPremiumUntil': 'Bạn sẽ giữ gói Cao cấp đến **{Date}**.',
    'Billing.LoadingAccount': 'Đang tải tài khoản…',
    'Billing.LoadingInvoices': 'Đang tải hóa đơn của bạn…',
    'Billing.LoadingPracticeBalance': 'Đang tải số lượt luyện hôm nay…',
    'Billing.ManageInPortal': 'Quản lý trong cổng Stripe',
    'Billing.MonthlyUsage': 'Đã dùng {Used} trên {Total} tín dụng hằng tháng của bạn.',
    'Billing.MsgAlreadySubscribed': 'Bạn đã có gói đăng ký đang hoạt động.',
    'Billing.MsgCancelFailed': 'Không thể hủy gói đăng ký. Vui lòng thử lại.',
    'Billing.MsgCancellationScheduled': 'Đã lên lịch hủy. Bạn vẫn giữ gói Cao cấp đến hết kỳ.',
    'Billing.MsgCancelling': 'Đang hủy gói đăng ký…',
    'Billing.MsgCheckoutFailed': 'Không thể bắt đầu thanh toán. Vui lòng thử lại.',
    'Billing.MsgNoActiveSubscription': 'Không có gói đăng ký nào đang hoạt động để hủy.',
    'Billing.MsgNoBillingAccount': 'Chưa có tài khoản thanh toán — hãy mua hàng trước.',
    'Billing.MsgOpeningPortal': 'Đang mở cổng thanh toán…',
    'Billing.MsgPleaseSignIn': 'Vui lòng đăng nhập.',
    'Billing.MsgPortalFailed': 'Không thể mở cổng thanh toán. Vui lòng thử lại.',
    'Billing.MsgSignInToBuy': 'Vui lòng đăng nhập để mua tín dụng.',
    'Billing.MsgSignInToResubscribe': 'Vui lòng đăng nhập để đăng ký lại.',
    'Billing.MsgTopUpRequiresPremium': 'Gói bổ sung dung lượng chỉ dành cho Cao cấp — hãy nâng cấp lên Cao cấp trước.',
    'Billing.MsgUnknownProduct': 'Sản phẩm không xác định. Vui lòng tải lại trang và thử lại.',
    'Billing.NoPayments': 'Chưa có khoản thanh toán nào. Hóa đơn sẽ xuất hiện ở đây sau lần thu phí đầu tiên.',
    'Billing.Opening': 'Đang mở…',
    'Billing.PaidPlusPremium': 'đã mua + ',
    'Billing.PastDueMeta': 'Lần thanh toán gần nhất thất bại — chúng tôi vẫn giữ gói Cao cấp trong khi Stripe thử lại. Hãy cập nhật phương thức thanh toán trong cổng khách hàng.',
    'Billing.PaymentHistory': 'Lịch sử thanh toán',
    'Billing.PeriodEnd': 'hết kỳ hiện tại',
    'Billing.PracticesLeftToday': 'lượt luyện còn lại hôm nay',
    'Billing.PremiumCreditsRemaining': 'tín dụng Cao cấp còn lại trong tháng này',
    'Billing.PremiumPlan': 'Cao cấp',
    'Billing.PremiumPriceLine': '{Price}$ / tháng · {Credits} tín dụng/tháng',
    'Billing.ProgressLink': 'Đang theo dõi kế hoạch 12 tuần? Xem [Tiến độ](/progress).',
    'Billing.RenewalInProgress': 'Kỳ gia hạn ngày {PeriodEnd} đang được xử lý — gói Cao cấp của bạn vẫn hoạt động trong lúc chờ.',
    'Billing.RenewsOn': 'Gia hạn vào **{Date}**.',
    'Billing.Resubscribe': 'Đăng ký lại',
    'Billing.StartingCheckout': 'Đang bắt đầu thanh toán…',
    'Billing.StatusActive': 'Đang hoạt động',
    'Billing.StatusCancellationScheduled': 'Đã lên lịch hủy',
    'Billing.StatusPaymentProblem': 'Sự cố thanh toán',
    'Billing.Storage': 'Lưu trữ đám mây',
    'Billing.StorageBuyPack': 'Thêm {Size}',
    'Billing.StoragePackPriceLine': '${Price} / tháng',
    'Billing.StorageTopUps': 'Thêm dung lượng',
    'Billing.StorageTopUpsLede': 'Các gói bổ sung hàng tháng mở rộng dung lượng lưu trữ Cao cấp của bạn. Chúng sẽ hết hạn khi gói Cao cấp kết thúc.',
    'Billing.StorageUsage': 'Đã dùng {Used} trên {Limit}',
    'Billing.StorageUsageAria': 'Đang dùng {Used} trên {Limit} dung lượng lưu trữ đám mây ({Percent}%).',
    'Billing.TabTitle': 'Thanh toán & tài khoản · VoiceDojo',
    'Billing.TakingToPricing': 'Đang đưa bạn đến bảng giá…',
    'Billing.Title': 'Thanh toán & tài khoản',
    'Billing.UpgradeToPremium': 'Nâng cấp lên Cao cấp',
    'Billing.ViewReceipt': 'Xem biên lai',
    'BillingCancel.BackToPricing': 'Quay lại bảng giá',
    'BillingCancel.BuyCredits': 'Mua tín dụng',
    'BillingCancel.CheckoutFailed': 'Không thể bắt đầu thanh toán, vui lòng thử lại.',
    'BillingCancel.Heading': 'Thanh toán chưa thành công',
    'BillingCancel.KeepPractising': 'Tiếp tục luyện tập',
    'BillingCancel.Lede': 'Đừng lo — **bạn chưa bị tính phí và không có gì thay đổi.** Tài khoản của bạn vẫn nguyên như cũ. Bạn muốn thử lại chứ?',
    'BillingCancel.Redirecting': 'Đang chuyển hướng…',
    'BillingCancel.Title': 'Thanh toán chưa thành công · VoiceDojo',
    'BillingCancel.TryAgain': 'Thử lại',
    'BillingSuccess.AiCredits': 'Tín dụng AI',
    'BillingSuccess.Cancel': 'Hủy',
    'BillingSuccess.CheckBalance': 'Kiểm tra số dư của bạn',
    'BillingSuccess.CheckEmailBody': 'Chúng tôi đã gửi liên kết đăng nhập tới {Email}. Hãy nhấp vào đó (hoặc nhập mã) để hoàn tất mở khóa giao dịch của bạn.',
    'BillingSuccess.CheckEmailHeading': 'Kiểm tra email của bạn',
    'BillingSuccess.ClaimError': 'Đã có lỗi khi gửi liên kết. Vui lòng thử lại.',
    'BillingSuccess.CloudStorage': 'Lưu trữ đám mây',
    'BillingSuccess.CollisionBody': 'Đã có một tài khoản dùng {Email}. Hãy xác nhận đó là của bạn và chúng tôi sẽ gửi email một liên kết đăng nhập để hoàn tất.',
    'BillingSuccess.CollisionConfirm': 'Đúng, gửi liên kết cho tôi',
    'BillingSuccess.CollisionDeny': 'Không, dùng email khác',
    'BillingSuccess.CollisionTitle': 'Đây có phải bạn không?',
    'BillingSuccess.ConfirmEmailBody': 'Chúng tôi sẽ gửi email một liên kết đăng nhập để xác nhận đây là bạn và mở khóa giao dịch của bạn.',
    'BillingSuccess.ConfirmEmailHeading': 'Xác nhận email của bạn để hoàn tất',
    'BillingSuccess.DailyPracticesLeft': 'Lượt luyện còn lại hôm nay',
    'BillingSuccess.EmailLabel': 'Email',
    'BillingSuccess.EmailRequired': 'Hãy nhập một địa chỉ email.',
    'BillingSuccess.Finalising': 'Đang hoàn tất giao dịch của bạn…',
    'BillingSuccess.FinalisingBody': 'Vui lòng đợi một chút trong khi chúng tôi xác nhận thanh toán.',
    'BillingSuccess.GoToBilling': 'Đến trang thanh toán',
    'BillingSuccess.MonthlyCreditsLeft': 'Tín dụng tháng còn lại',
    'BillingSuccess.NameLabel': 'Tên của bạn',
    'BillingSuccess.NameOptional': 'Tên của bạn (không bắt buộc)',
    'BillingSuccess.OtpEnterCode': 'Hãy nhập mã 6 chữ số từ email.',
    'BillingSuccess.OtpExpired': 'Mã đó đã hết hạn — hãy gửi lại liên kết để nhận mã mới.',
    'BillingSuccess.OtpInvalid': 'Mã đó không khớp. Hãy kiểm tra email và thử lại.',
    'BillingSuccess.OtpLabel': 'Hoặc nhập mã 6 chữ số',
    'BillingSuccess.OtpTooManyAttempts': 'Quá nhiều lần thử. Hãy gửi lại liên kết để nhận mã mới.',
    'BillingSuccess.QuotaOf': '{Remaining} trên {Limit}',
    'BillingSuccess.ReceiptGeneric': 'Thanh toán hoàn tất',
    'BillingSuccess.ReceiptGenericBody': 'Cảm ơn — giao dịch của bạn đã được xác nhận.',
    'BillingSuccess.ReceiptPack': 'Bạn đã thêm {Pack}',
    'BillingSuccess.ReceiptPackBody': 'Tín dụng của bạn đã sẵn sàng để sử dụng.',
    'BillingSuccess.ReceiptSubscription': 'Bạn đã là Premium',
    'BillingSuccess.ReceiptSubscriptionBody': 'Gói đăng ký của bạn đang hoạt động — bao gồm {Credits} tín dụng/tháng.',
    'BillingSuccess.ReceiptTopUp': 'Đã thêm dung lượng',
    'BillingSuccess.ReceiptTopUpBody': 'Gói bổ sung {Size} dung lượng của bạn đang hoạt động — thêm chỗ để lưu các bản thu.',
    'BillingSuccess.Recovery': 'Để dùng VoiceDojo trên thiết bị khác, hãy đăng nhập bằng email của bạn — không cần mật khẩu, chỉ một liên kết đăng nhập.',
    'BillingSuccess.ResendLink': 'Gửi lại liên kết',
    'BillingSuccess.SaveAccountHeading': 'Lưu tài khoản của bạn',
    'BillingSuccess.SavedNoEmail': 'Tài khoản của bạn được lưu dưới email bạn đã dùng để thanh toán.',
    'BillingSuccess.SavedUnder': 'Đã lưu dưới **{Email}**.',
    'BillingSuccess.SendLink': 'Gửi liên kết',
    'BillingSuccess.SendingLink': 'Đang gửi liên kết…',
    'BillingSuccess.StartPractising': 'Bắt đầu luyện tập',
    'BillingSuccess.Title': 'Thanh toán hoàn tất · VoiceDojo',
    'BillingSuccess.Updating': 'Đang cập nhật số dư của bạn… việc này mất hơi lâu hơn bình thường.',
    'BillingSuccess.UseDifferentEmail': 'Dùng email khác',
    'BillingSuccess.Verifying': 'Đang xác minh…',
    'CheckoutEmail.Body': 'Tín dụng và gói Cao cấp của bạn gắn với email, nên chúng tôi hỏi trước khi bạn thanh toán — để giao dịch vào đúng tài khoản bạn đã có, thay vì tạo thêm một tài khoản nữa.',
    'CheckoutEmail.Cancel': 'Hủy',
    'CheckoutEmail.Continue': 'Tiếp tục thanh toán',
    'CheckoutEmail.EmailInvalid': 'Địa chỉ email không hợp lệ.',
    'CheckoutEmail.EmailLabel': 'Email',
    'CheckoutEmail.EmailRequired': 'Nhập email của bạn để tiếp tục.',
    'CheckoutEmail.Failed': 'Không thể bắt đầu thanh toán. Vui lòng thử lại.',
    'CheckoutEmail.Heading': 'Giao dịch này thuộc về email nào?',
    'CheckoutEmail.SignInBody': 'Đã có một tài khoản VoiceDojo với {Email}. Hãy đăng nhập và mua từ đó, để giao dịch này vào đúng tài khoản bạn đã có.',
    'CheckoutEmail.SignInCta': 'Đăng nhập',
    'CheckoutEmail.SignInHeading': 'Bạn đã có tài khoản',
    'CheckoutEmail.SignInUseAnother': 'Dùng email khác',
    'CheckoutEmail.Working': 'Đang bắt đầu thanh toán…',
    'CreditLedger.AllowanceDebtRepaid': '{Debt} đã được trả từ hạn mức tháng này',
    'CreditLedger.AllowanceLapsed': '{Lapsed} tín dụng còn lại của hạn mức trước đã hết hạn',
    'CreditLedger.ColumnAmount': 'Số lượng',
    'CreditLedger.ColumnBalance': 'Số dư',
    'CreditLedger.ColumnDate': 'Ngày',
    'CreditLedger.ColumnType': 'Loại',
    'CreditLedger.EventsEmpty': 'Chưa có sự kiện tín dụng nào.',
    'CreditLedger.Heading': 'Lịch sử tín dụng',
    'CreditLedger.Lede': 'Mọi lần mua, tặng, trừ và hoàn tín dụng AI của bạn, mới nhất trước.',
    'CreditLedger.LiveMinutes': '{Minutes} phút',
    'CreditLedger.LoadFailed': 'Không thể tải lịch sử tín dụng.',
    'CreditLedger.Loading': 'Đang tải lịch sử tín dụng…',
    'CreditLedger.MonthlyAllowance': 'Hạn mức hàng tháng → {Allowance}',
    'CreditLedger.Pack': 'Gói {Pack} ({Credits} tín dụng)',
    'CreditLedger.PackRefund': 'Đã hoàn gói · {Pack}',
    'CreditLedger.Refund': 'Hoàn lại',
    'CreditLedger.RefundedInFull': 'đã hoàn toàn bộ',
    'CreditLedger.Settled': 'giữ {Reserved}, hoàn {Refunded}',
    'CreditLedger.Settling': 'giữ {Reserved}, đang quyết toán…',
    'CreditLedger.ShowMore': 'Xem thêm',
    'CreditLedger.SourceActiveListening': 'Lắng nghe chủ động',
    'CreditLedger.SourceAiReview': 'Đánh giá AI',
    'CreditLedger.SourceDeliveryPlan': 'Kế hoạch trình bày',
    'CreditLedger.SourceLiveConvo': 'Hội thoại trực tiếp',
    'CreditLedger.SourceLivePitch': 'Thuyết trình trực tiếp',
    'CreditLedger.SourceRehearsalPdfRecognition': 'Nhập PDF tập dượt',
    'CreditLedger.SourceRehearsalPlan': 'Kế hoạch tập dượt',
    'CreditLedger.SourceRewrite': 'Viết lại để nói',
    'CreditLedger.TakeUnsaved': 'bản ghi chưa lưu',
    'CreditLedger.TimesIn': 'Giờ theo {Zone}',
    'CreditLedger.TypeAdminAdjust': 'Quản trị điều chỉnh',
    'CreditLedger.TypeSignupBonus': 'Thưởng đăng ký',
    'CreditLedger.TypeSupportAdjust': 'Điều chỉnh bởi bộ phận hỗ trợ VoiceDojo',
    'CreditReceipt.ChargedMany': 'Đã trừ {Charged} tín dụng · bạn còn {Balance}',
    'CreditReceipt.ChargedOne': 'Đã trừ {Charged} tín dụng · bạn còn {Balance}',
    'CreditReceipt.HistoryLink': 'Lịch sử tín dụng',
    'CreditReceipt.LiveMany': '{Minutes} phút · {Charged} tín dụng · bạn còn {Balance}',
    'CreditReceipt.LiveOne': '{Minutes} phút · {Charged} tín dụng · bạn còn {Balance}',
    'CreditReceipt.SettledMany': 'Đã trừ {Charged} tín dụng (giữ {Reserved}, hoàn {Refunded}) · bạn còn {Balance}',
    'CreditReceipt.SettledOne': 'Đã trừ {Charged} tín dụng (giữ {Reserved}, hoàn {Refunded}) · bạn còn {Balance}',
    'Culture.English': 'English',
    'Culture.EnglishShort': 'EN',
    'Culture.ToggleAria': 'Đổi ngôn ngữ',
    'Culture.Vietnamese': 'Tiếng Việt',
    'Culture.VietnameseShort': 'VI',
    'DataExport.Copied': 'Đã sao chép liên kết.',
    'DataExport.CopyAll': 'Sao chép tất cả liên kết',
    'DataExport.DownloadAll': 'Tải tất cả',
    'DataExport.Expired': 'Liên kết tải xuống này đã hết hạn. Các tệp đã bị xóa.',
    'DataExport.Failed': 'Chúng tôi không thể tải danh sách tệp. Vui lòng thử lại.',
    'DataExport.FilesHeading': 'Tệp',
    'DataExport.Heading': 'Tải dữ liệu của bạn',
    'DataExport.Intro': 'Tài khoản của bạn đã bị xóa. Các tệp này có sẵn đến {Date}; sau đó chúng sẽ bị xóa vĩnh viễn.',
    'DataExport.Loading': 'Đang tải danh sách tệp…',
    'DataExport.ManagerTip': 'Có thể có nhiều bản thu dung lượng lớn, vì vậy chúng tôi khuyên dùng trình quản lý tải xuống: sao chép tất cả liên kết và dán vào đó.',
    'DataExport.NotFound': 'Liên kết tải xuống này không hợp lệ.',
    'DataExport.Title': 'Tải dữ liệu của bạn · VoiceDojo',
    'EditableName.Cancel': 'Hủy',
    'EditableName.Confirm': 'Đổi tên',
    'EditableName.DialogHeading': 'Đổi tên lượt này',
    'EditableName.DismissAria': 'Đóng mà không đổi tên',
    'EditableName.EditAria': 'Chỉnh sửa tên phiên',
    'EditableName.ErrorEmpty': 'Tên không được để trống.',
    'EditableName.ErrorFailed': 'Không thể đổi tên ({Status}).',
    'EditableName.ErrorNetwork': 'Lỗi mạng — tên đã được hoàn nguyên.',
    'EditableName.NameLabel': 'Tên',
    'EditableName.RenameTitle': 'Nhấn để đổi tên',
    'EditableName.Saved': 'Đã lưu',
    'EditableName.Saving': 'Đang lưu…',
    'EditableName.Untitled': 'Phiên không tên',
    'Errors.Unexpected': 'Đã xảy ra sự cố. Vui lòng thử lại.',
    'Focus.CueHistoryAria': 'Lịch sử gợi ý',
    'Focus.EndCancel': 'Hủy',
    'Focus.EndConfirm': 'Kết thúc',
    'Focus.EndConfirmTitle': 'Bạn có chắc muốn kết thúc phiên không?',
    'Focus.EndSessionAria': 'Kết thúc phiên',
    'Focus.ExitAria': 'Thoát',
    'Focus.ExitConfirmBodyCredit': 'Tín dụng AI đã dùng để tạo bài luyện này sẽ bị mất — không được hoàn lại.',
    'Focus.ExitConfirmBodyQuota': 'Lượt luyện tập trong ngày đã dùng để tạo bài luyện này sẽ bị mất — không được hoàn lại.',
    'Focus.ExitConfirmForfeitCredit': 'Có, chấp nhận mất tín dụng',
    'Focus.ExitConfirmForfeitQuota': 'Có, chấp nhận mất lượt luyện tập',
    'Focus.ExitConfirmNo': 'Không',
    'Focus.ExitConfirmTitle': 'Bạn có chắc muốn hủy phiên luyện tập này không?',
    'Focus.FallbackTitle': 'Buổi luyện tập',
    'Focus.KeyboardShortcut': 'Phím tắt: {Key}',
    'Focus.Pause': 'Tạm dừng',
    'Focus.PausedWhileAway': 'Đã tạm dừng khi bạn rời đi. Nhấn Tiếp tục hoặc phím Space để tiếp tục.',
    'Focus.Resume': 'Tiếp tục',
    'Focus.SessionTitle': '{Practice} · {Name}',
    'Focus.StartLabel': 'Ghi hình',
    'Focus.TimeOfPlanned': '{Elapsed} / {Planned}',
    'Footer.About': 'Giới thiệu',
    'Footer.Copyright': '© VoiceDojo',
    'Footer.LegalAria': 'Pháp lý và bảng giá',
    'Footer.Pricing': 'Bảng giá',
    'Footer.Privacy': 'Chính sách bảo mật',
    'Footer.Support': 'Hỗ trợ',
    'Footer.SupportEmail': 'support@voicedojo.ai',
    'Footer.Terms': 'Điều khoản dịch vụ',
    'Footer.ThirdParty': 'Thông báo bên thứ ba',
    'HomeMove.Banner': 'Đang chuyển tài khoản của bạn đến {Region} — bạn vẫn có thể tiếp tục ghi âm. Tính năng lưu và AI sẽ trở lại sau vài phút.',
    'HomeMove.BannerUnknownRegion': 'Đang chuyển tài khoản của bạn sang khu vực khác — bạn vẫn có thể tiếp tục ghi âm. Tính năng lưu và AI sẽ trở lại sau vài phút.',
    'HomeMove.Region.Au': 'Úc',
    'HomeMove.Region.Na': 'Bắc Mỹ',
    'HomeMove.Region.Sg': 'Singapore',
    'Impersonation.ActingAs': 'Đang mạo danh {Name}',
    'Impersonation.ActingAsDetail': 'Đang mạo danh {Name} · {Email}',
    'Impersonation.ActionUnavailable': 'Không khả dụng khi đang mạo danh',
    'Impersonation.Badge': 'Đang mạo danh',
    'Impersonation.FailedToStop': 'Không thể dừng mạo danh.',
    'Impersonation.IdentityAria': 'Phiên mạo danh',
    'Impersonation.Reason': 'Lý do: {Reason}',
    'Impersonation.SignedInAs': 'Đăng nhập với tư cách {Email}',
    'Impersonation.StopAria': 'Dừng mạo danh',
    'Impersonation.StopIdle': 'Dừng mạo danh',
    'Impersonation.StopStopping': 'Đang dừng…',
    'Layout.AboutLabel': 'Giới thiệu về VoiceDojo',
    'Layout.Offline': '**Ngoại tuyến** — không kết nối được máy chủ. Bạn vẫn có thể luyện tập với gợi ý ngẫu nhiên; nội dung/đánh giá AI, nhạc nền, lịch sử và đăng nhập tạm thời không khả dụng.',
    'LearningStage.ConsciousCompetence': 'Ý thức thành thạo',
    'LearningStage.ConsciousIncompetence': 'Ý thức bất tài',
    'LearningStage.UnconsciousCompetence': 'Vô thức thành thạo',
    'LearningStage.UnconsciousIncompetence': 'Vô thức bất tài',
    'LocalCache.FallbackTakeName': 'Bản thu {Practice}',
    'LocalCache.ListFailed': 'Không đọc được các bản ghi đang lưu trên thiết bị này.',
    'LocalCache.SaveFailed': 'Không thể giữ bản ghi này trên thiết bị — nó sẽ mất khi bạn tải lại trang. Hãy tải xuống hoặc lưu vào thư viện ngay.',
    'LocalCache.StorageFull': 'Bộ nhớ trình duyệt đã đầy nên bản ghi này không được giữ trên thiết bị — nó sẽ mất khi bạn tải lại trang. Hãy tải xuống hoặc lưu vào thư viện ngay.',
    'MicLevel.MeterAria': 'Mức tín hiệu micro',
    'MicLevel.QuietHint': 'Micro của bạn nghe rất nhỏ. Hãy thử nói ở âm lượng bình thường, ngồi gần micro hơn, hoặc chọn micro khác trước khi ghi.',
    'NameDialog.DismissAria': 'Đóng',
    'NameDialog.Heading': 'Chào mừng đến VoiceDojo. Chúng tôi nên gọi bạn là gì?',
    'NameDialog.NameLabel': 'Tên',
    'NameDialog.NamePlaceholder': 'Tên của bạn',
    'NameDialog.Save': 'Lưu',
    'NameDialog.SaveAria': 'Lưu tên',
    'NameDialog.Saving': 'Đang lưu…',
    'Nav.Account': 'Tài khoản',
    'Nav.ActiveListening': 'Lắng nghe chủ động',
    'Nav.Archetype': 'Nguyên mẫu',
    'Nav.BodyLanguage': 'Ngôn ngữ cơ thể',
    'Nav.CloseNav': 'Đóng điều hướng',
    'Nav.Instrument': 'Nhạc cụ',
    'Nav.Library': 'Thư viện của tôi',
    'Nav.Mastery': 'Tinh thông',
    'Nav.MasteryLockTooltip': 'Hãy đăng ký!',
    'Nav.OpenNav': 'Mở điều hướng',
    'Nav.Playground': 'Sân chơi',
    'Nav.PracticeNavAria': 'Điều hướng bài luyện',
    'Nav.PremiumLockTooltip': 'Chỉ dành cho Cao cấp',
    'Nav.Progress': 'Tiến độ',
    'Nav.RecordReview': 'Diễn tập',
    'Nav.Riff': 'Ứng tác',
    'Nav.Storytelling': 'Kể chuyện',
    'Nav.Wordmark': 'VoiceDojo',
    'NewVersion.Body': 'Phiên bản mới của ứng dụng web đã được phát hành. Vui lòng tải lại trình duyệt.',
    'NewVersion.Later': 'Hủy - tôi sẽ tải lại sau',
    'NewVersion.Refresh': 'Tải lại',
    'NewVersion.Title': 'Đã có phiên bản mới',
    'Offline.AccuracyNote': 'Nội dung luyện tập do AI tạo có thể không chính xác — hãy dùng để luyện tập, đừng xem là sự thật.',
    'Offline.Advanced': 'Nâng cao',
    'Offline.AdvancedHint': 'Chọn một mô hình sẽ tải về một lần và lưu đệm trong trình duyệt; chủ đề chỉ áp dụng cho lượt tập kế tiếp.',
    'Offline.BuiltWithLlama': 'Built with Llama',
    'Offline.CatalogUnavailable': 'không tải được danh sách mô hình trên thiết bị và thiết bị này chưa lưu bản sao nào; hãy kiểm tra kết nối mạng',
    'Offline.Incoherent': 'Mô hình trên thiết bị trả về những từ rời rạc chứ không phải câu văn — chỉ {Percent}% là từ nối thông thường. Hãy thử lại, hoặc chọn mô hình lớn hơn trong mục Nâng cao.',
    'Offline.LicencesLink': 'Giấy phép mô hình',
    'Offline.LoadFailed': 'Không tải được mô hình: {Error}. Hãy bật/tắt lại chế độ Ngoại tuyến hoặc chọn mô hình khác.',
    'Offline.ModelLabel': 'Mô hình',
    'Offline.OfferAccept': 'Có — bật AI ngoại tuyến',
    'Offline.OfferBody': 'Thiết bị này có thể tự chạy AI của VoiceDojo: chế độ ngoại tuyến tạo nội dung luyện tập ngay trên thiết bị, sau khi tải về một lần khoảng {SizeMb} MB. Bạn có thể tắt bất cứ lúc nào bằng công tắc Chế độ ngoại tuyến.',
    'Offline.OfferDecline': 'Để sau',
    'Offline.OfferPrivacy': 'AI ngoại tuyến chạy ngay trong trình duyệt của bạn. Nội dung AI tạo ra và bản thu của bạn đều nằm lại trên thiết bị này. [Tìm hiểu thêm](/privacy#bên-xử-lý-dữ-liệu-thứ-ba)',
    'Offline.OfferTitle': 'Chạy AI ngay trên thiết bị này?',
    'Offline.Recommended': 'khuyên dùng',
    'Offline.Repetitive': 'Mô hình trên thiết bị lặp lại chính nó — chỉ {Percent}% bài viết là nội dung mới. Hãy thử lại, hoặc chọn mô hình lớn hơn trong mục Nâng cao.',
    'Offline.ShowAll': 'Xem tất cả',
    'Offline.StateDownloading': 'đang tải',
    'Offline.StateLoading': 'đang nạp',
    'Offline.StateReady': 'sẵn sàng',
    'Offline.Subtitle': 'Chạy trong trình duyệt · không tốn hạn mức',
    'Offline.TierLarge': 'Lớn (cần GPU mạnh)',
    'Offline.TierMedium': 'Trung bình',
    'Offline.TierSmall': 'Nhỏ',
    'Offline.TierTiny': 'Rất nhỏ',
    'Offline.Title': 'Chế độ ngoại tuyến',
    'Offline.ToggleAria': 'Chế độ ngoại tuyến — tạo nội dung ngay trên thiết bị, không tốn hạn mức hằng ngày',
    'Offline.TooShort': 'Mô hình trên thiết bị chỉ trả về {Words} từ thay vì khoảng {Target} từ. Hãy thử lại, hoặc chọn mô hình lớn hơn trong mục Nâng cao.',
    'Offline.WorkerMessageFailed': 'Luồng xử lý của mô hình trên thiết bị gửi dữ liệu mà trang này không đọc được. Hãy bật/tắt lại chế độ Ngoại tuyến để khởi động lại.',
    'Pending.CreditsSettingUp': 'Đang thiết lập tín dụng AI của bạn',
    'Pending.CreditsStuck': 'Tín dụng AI của bạn vẫn chưa được thiết lập.',
    'Pending.ParseStuck': 'Việc đọc tệp PDF của bạn đang quá lâu. Thử lại không tốn thêm phí.',
    'Pending.PlanStuck': 'Việc tạo kế hoạch trình bày này đang quá lâu. Thử lại không tốn thêm phí.',
    'Pending.PurchaseApplying': 'Đang áp dụng giao dịch mua của bạn',
    'Pending.PurchaseStuck': 'Giao dịch mua của bạn vẫn chưa được áp dụng.',
    'Pending.Retry': 'Thử lại',
    'Pending.ReviewStuck': 'Đánh giá AI của bạn vẫn chưa bắt đầu.',
    'Playback.CoachingCuesCount': 'Gợi ý huấn luyện · {Count}',
    'Playback.CueSeekHint': 'Chạm vào một gợi ý để tua đến đó',
    'Playback.CurrentTime': 'Thời gian hiện tại',
    'Playback.Loading': 'Đang tải bản thu…',
    'Playback.Pause': 'Tạm dừng phát',
    'Playback.Play': 'Phát bản thu',
    'Playback.SeekAria': 'Tua bản thu',
    'Playback.TotalDuration': 'Tổng thời lượng',
    'Playback.Unsupported': 'Trình duyệt của bạn không xem trước được video này — tệp đã lưu vẫn phát được trong trình phát media của bạn.',
    'Playback.VideoAria': 'Phát lại video đã ghi',
    'PostTakeReview.AwaitingUpload': 'Đang lưu bản thu này vào thư viện trước — Đánh giá AI sẽ mở ngay khi tải lên xong.',
    'PostTakeReview.DiscardConfirmBody': 'Bản thu sẽ bị xoá khỏi thiết bị này. Không thể hoàn tác.',
    'PostTakeReview.DiscardConfirmTitle': 'Bỏ bản thu này?',
    'PostTakeReview.DiscardTake': 'Bỏ bản thu',
    'PostTakeReview.Discarded': 'Đã xoá khỏi thiết bị này — bản thu sẽ mất khi bạn rời trang.',
    'PostTakeReview.DownloadVideo': 'Tải video xuống',
    'PostTakeReview.KeepManage': 'Quản lý',
    'PostTakeReview.MoreActionsAria': 'Thao tác khác',
    'PostTakeReview.ReviewGuestReason': 'Bản thu của bạn vẫn nằm trên thiết bị này — chúng tôi sẽ đưa bạn quay lại ngay với nó.',
    'PostTakeReview.ReviewNoCredits': 'Bạn đã hết tín dụng AI.',
    'PostTakeReview.ReviewSignIn': 'Đăng nhập để đánh giá',
    'PostTakeReview.SeriesLocalOnly': 'Bản thu này đang ở trên thiết bị này. Nó chỉ vào chuỗi khi bạn lưu lại hoặc yêu cầu AI đánh giá.',
    'PostTakeReview.StripCreateAccount': 'Tạo tài khoản',
    'PostTakeReview.StripLocalSub': 'Nó nằm trên thiết bị này {Days} ngày, rồi biến mất.',
    'PostTakeReview.StripSavedSub': 'Được giữ lại tự động.',
    'PostTakeReview.StripSavedTitle': 'Đã lưu vào thư viện của bạn',
    'PostTakeReview.StripSavingSub': 'Tự động — thiết lập của bạn giữ lại mọi bản thu.',
    'PostTakeReview.StripSavingTitle': 'Đang lưu vào thư viện của bạn',
    'PostTakeReview.StripSeePremium': 'Xem Premium',
    'PostTakeReview.TakeComplete': 'Đã xong bản thu',
    'PracticeLabel.ActiveListening': 'Lắng nghe chủ động',
    'PracticeLabel.ArchetypePlay': 'Nguyên mẫu',
    'PracticeLabel.BodyLanguagePlay': 'Ngôn ngữ cơ thể',
    'PracticeLabel.RecordAndReview': 'Diễn tập',
    'PracticeLabel.Riff': 'Ứng tác',
    'PracticeLabel.Standalone': 'Tải lên độc lập',
    'PracticeLabel.Storytelling': 'Kể chuyện',
    'PracticeLabel.TheInstrument': 'Nhạc cụ',
    'PracticeView.AiGuide': 'Hướng dẫn AI',
    'PracticeView.ContentError': 'Hướng dẫn AI không viết được câu chuyện cho bạn. Bạn vẫn có thể ghi — hãy đọc to bất cứ điều gì bạn thích và chơi với các phím.',
    'PracticeView.ContentLoading': 'AI đang viết cho bạn một đoạn ngắn để đọc…',
    'PracticeView.CueLiveNow': 'gợi ý đang phát',
    'PracticeView.CuesSoFar': 'Các gợi ý đến giờ',
    'PracticeView.KindToReadAloud': '{Kind} để đọc to',
    'PracticeView.ReadAloud': 'đọc to',
    'PracticeView.TokenCount': '{Count} từ',
    'Pricing.BuyPack': 'Mua {Pack}',
    'Pricing.Capacity': '**Gói Cao cấp hiện đã đầy.** Tham gia danh sách chờ — chúng tôi sẽ gửi email khi có chỗ trống.',
    'Pricing.Costs': 'Đánh giá AI từ {ReviewFrom} tín dụng (tùy chỉnh — mô hình, Nỗ lực + tốc độ khung hình) · Lắng nghe chủ động {ActiveListening} tín dụng · Hội thoại trực tiếp từ {LiveConvo} tín dụng/phút',
    'Pricing.DemoFreeUnavailable': 'Trình duyệt của bạn không đọc được gợi ý.',
    'Pricing.DemoFreeVoice': 'Giọng miễn phí',
    'Pricing.DemoLede': 'Các gợi ý trực tiếp được đọc thành tiếng. Giọng Cao cấp minh họa từng chỉ dẫn — "To hơn" được nói to hơn. Giọng trình duyệt miễn phí chỉ đọc lời. Cùng một câu, cách thể hiện khác nhau:',
    'Pricing.DemoLoading': 'Đang tải…',
    'Pricing.DemoPremiumUnavailable': 'Mẫu hiện không khả dụng.',
    'Pricing.DemoPremiumVoice': 'Giọng Cao cấp',
    'Pricing.DemoTitle': 'Nghe sự khác biệt',
    'Pricing.FirstFreeCredits': '**{SignupBonus} tín dụng đầu tiên miễn phí.** Mỗi tài khoản mới nhận {SignupBonus} tín dụng AI miễn phí khi đăng ký — đủ để thử mọi tính năng AI. Không cần thẻ.',
    'Pricing.Footnote': 'Thắc mắc về thanh toán? Xem [bảng điều khiển thanh toán](/billing) hoặc xem lại [Điều khoản](/terms) và [Chính sách bảo mật](/privacy).',
    'Pricing.FreeCta': 'Bắt đầu ghi',
    'Pricing.FreeFeatureDownload': 'Tải về bản thu của bạn',
    'Pricing.FreeFeatureNoServerStorage': 'Không lưu trữ trên máy chủ',
    'Pricing.FreeFeatureRecordLocally': 'Ghi cục bộ ngay trong trình duyệt',
    'Pricing.FreeFeatureSignupBonus': '{SignupBonus} tín dụng AI thưởng khi đăng ký',
    'Pricing.FreePrice': '0₫',
    'Pricing.FreeTitle': 'Miễn phí',
    'Pricing.Lede': 'Một loại tín dụng AI duy nhất. Trả theo lượt dùng, hoặc đăng ký để nhận hạn mức hằng tháng.',
    'Pricing.LegalAgree': 'Khi mua, bạn đồng ý với [Điều khoản](/terms) và [Chính sách bảo mật](/privacy).',
    'Pricing.Loading': 'Đang tải',
    'Pricing.MsgAlreadySubscribed': 'Bạn đã có gói đăng ký đang hoạt động.',
    'Pricing.MsgCheckoutFailed': 'Không thể bắt đầu thanh toán. Vui lòng thử lại.',
    'Pricing.MsgEnterEmail': 'Vui lòng nhập email của bạn.',
    'Pricing.MsgFreeDemoUnavailable': 'Trình duyệt của bạn không hỗ trợ gợi ý bằng giọng nói.',
    'Pricing.MsgPremiumDemoUnavailable': 'Mẫu giọng Cao cấp hiện không khả dụng.',
    'Pricing.MsgSignInToBuy': 'Vui lòng đăng nhập để mua tín dụng.',
    'Pricing.MsgSignInToSubscribe': 'Vui lòng đăng nhập để đăng ký.',
    'Pricing.MsgStartingCheckout': 'Đang bắt đầu thanh toán…',
    'Pricing.MsgStartingSubscription': 'Đang bắt đầu đăng ký…',
    'Pricing.MsgUnknownProduct': 'Sản phẩm không xác định. Vui lòng tải lại trang và thử lại.',
    'Pricing.MsgWaitlistAdmitted': 'Bạn đã được nhận — hãy hoàn tất đăng ký bên dưới.',
    'Pricing.MsgWaitlistFailed': 'Không thể tham gia danh sách chờ. Vui lòng thử lại.',
    'Pricing.MsgWaitlistPosition': 'Bạn ở vị trí #{Position} trong danh sách chờ. Chúng tôi sẽ gửi email khi có chỗ trống.',
    'Pricing.MsgWaitlistSlotOpen': 'Đã có một chỗ Cao cấp dành cho bạn. Chúng tôi đã gửi email kèm liên kết thanh toán.',
    'Pricing.PacksFeatureNeverExpire': 'Tín dụng không bao giờ hết hạn',
    'Pricing.PacksFeatureRetention': 'Bản thu đã đánh giá được giữ {Days} ngày sau khi đánh giá',
    'Pricing.PacksFeatureSpend': 'Dùng tín dụng cho mọi tính năng AI',
    'Pricing.PacksPrice': 'Trả theo lượt dùng',
    'Pricing.PacksTitle': 'Gói tín dụng AI',
    'Pricing.PremiumCurrentPlan': 'Gói hiện tại của bạn',
    'Pricing.PremiumFeatureCredits': '{Credits} tín dụng AI mỗi tháng',
    'Pricing.PremiumFeatureOverage': 'Vượt hạn mức qua gói tín dụng trả phí cùng mức giá',
    'Pricing.PremiumFeatureRetention': 'Bạn tự chọn thời gian giữ bản thu',
    'Pricing.PremiumFeatureStorage': 'Bao gồm 100 GB dung lượng lưu bản thu',
    'Pricing.PremiumManageLink': 'Quản lý gói đăng ký của bạn',
    'Pricing.PremiumPrice': '{Price}$ / tháng',
    'Pricing.PremiumTitle': 'Cao cấp',
    'Pricing.Redirecting': 'Đang chuyển hướng…',
    'Pricing.StartSubscription': 'Bắt đầu đăng ký',
    'Pricing.TabTitle': 'Bảng giá · VoiceDojo',
    'Pricing.TiersAria': 'Các gói giá',
    'Pricing.Title': 'Bảng giá',
    'Pricing.WaitlistEmailLabel': 'Địa chỉ email của bạn',
    'Pricing.WaitlistEmailPlaceholder': 'you@example.com',
    'Pricing.WaitlistFormAria': 'Tham gia danh sách chờ Cao cấp',
    'Pricing.WaitlistJoin': 'Tham gia danh sách chờ',
    'Pricing.WaitlistJoining': 'Đang tham gia…',
    'Profile.AiCreditsLabel': 'tín dụng AI',
    'Profile.AiCreditsSuffix': 'tín dụng AI',
    'Profile.AppVersion': 'Phiên bản ứng dụng',
    'Profile.AvatarLabel': 'Ảnh đại diện',
    'Profile.AvatarSectionAria': 'Ảnh đại diện của bạn',
    'Profile.AvatarUpload': 'Tải ảnh lên',
    'Profile.AvatarUploading': 'Đang tải lên…',
    'Profile.Cancel': 'Hủy',
    'Profile.ConfirmCopy': 'Hành động này không thể hoàn tác. Nhập email **{Email}** để xác nhận.',
    'Profile.ConfirmEmailLabel': 'Xác nhận email của bạn',
    'Profile.Contact': 'Có thắc mắc? Gửi email [{Email}](mailto:{Email}).',
    'Profile.CreditsSectionAria': 'Tín dụng của bạn',
    'Profile.DangerCopy': 'Việc xóa tài khoản là **ngay lập tức và vĩnh viễn**. Quyền truy cập của bạn kết thúc ngay lập tức, sau đó chúng tôi xóa các bản thu, đánh giá và tài khoản của bạn, và hủy mọi gói đăng ký đang hoạt động. **Không có cách nào khôi phục chúng.**',
    'Profile.DangerLabel': 'Vùng nguy hiểm',
    'Profile.DangerPremiumExport': 'Là thành viên Premium, bạn sẽ nhận được email chứa liên kết riêng để tải bản thu và dữ liệu của mình. Liên kết có hiệu lực trong 7 ngày; sau đó mọi thứ sẽ bị xóa.',
    'Profile.DangerSectionAria': 'Xóa tài khoản',
    'Profile.DeleteMyAccount': 'Xóa tài khoản của tôi',
    'Profile.Deleting': 'Đang xóa…',
    'Profile.Heading': 'Hồ sơ',
    'Profile.HelpLabel': 'Trợ giúp & liên hệ',
    'Profile.HelpSectionAria': 'Trợ giúp và liên hệ',
    'Profile.IncludedThisMonth': '· {Count} đã bao gồm trong tháng này',
    'Profile.ManageSubscription': 'Quản lý gói đăng ký',
    'Profile.NameLabel': 'Tên',
    'Profile.NamePlaceholder': 'Tên của bạn',
    'Profile.NameSectionAria': 'Tên của bạn',
    'Profile.PermanentlyDelete': 'Xóa vĩnh viễn',
    'Profile.PermanentlyDeleteAria': 'Xóa vĩnh viễn tài khoản của tôi',
    'Profile.PracticesLeftToday': '{Remaining} trên {Limit} lượt luyện còn lại hôm nay',
    'Profile.PricingLink': 'Bảng giá & gói tín dụng',
    'Profile.PrivacyLink': 'Chính sách bảo mật',
    'Profile.Save': 'Lưu',
    'Profile.SaveAria': 'Lưu hồ sơ',
    'Profile.Saved': 'Đã lưu.',
    'Profile.Saving': 'Đang lưu…',
    'Profile.StorageSectionAria': 'Dung lượng lưu trữ bản thu trên đám mây của bạn',
    'Profile.TermsLink': 'Điều khoản dịch vụ',
    'Profile.TimeZoneCurrentTime': 'Giờ hiện tại: {Time}',
    'Profile.TimeZoneLabel': 'Múi giờ',
    'Profile.TimeZoneRegionAfrica': 'Châu Phi',
    'Profile.TimeZoneRegionAmerica': 'Châu Mỹ',
    'Profile.TimeZoneRegionAntarctica': 'Châu Nam Cực',
    'Profile.TimeZoneRegionArctic': 'Bắc Cực',
    'Profile.TimeZoneRegionAsia': 'Châu Á',
    'Profile.TimeZoneRegionAtlantic': 'Đại Tây Dương',
    'Profile.TimeZoneRegionAustralia': 'Úc',
    'Profile.TimeZoneRegionEurope': 'Châu Âu',
    'Profile.TimeZoneRegionIndian': 'Ấn Độ Dương',
    'Profile.TimeZoneRegionOther': 'Khác',
    'Profile.TimeZoneRegionPacific': 'Thái Bình Dương',
    'Profile.TimeZoneSectionAria': 'Múi giờ của bạn',
    'Profile.TimeZoneUseDevice': 'Dùng múi giờ của thiết bị ({Zone})',
    'Profile.Title': 'Hồ sơ · VoiceDojo',
    'Profile.TopUpCredits': 'Nạp thêm tín dụng',
    'Profile.WpmHint': 'Canh độ dài nội dung luyện tập do AI tạo theo độ dài bản thu của bạn, và đặt tốc độ chạy của phần chữ được tô sáng trong kịch bản.',
    'Profile.WpmLabel': 'Tốc độ nói ưa thích',
    'Profile.WpmNumberAria': 'Số từ mỗi phút ưa thích',
    'Profile.WpmSectionAria': 'Tốc độ nói ưa thích',
    'Profile.WpmSuffix': 'từ mỗi phút',
    'Recording.CueVoiceVolume': 'Âm lượng giọng đọc gợi ý',
    'Recording.CuesOff': 'Gợi ý đang tắt',
    'Recording.CuesOn': 'Gợi ý đang bật',
    'Recording.DownloadPracticeText': 'Tải về nội dung bài luyện',
    'Recording.LivePreviewAria': 'Xem trước camera trực tiếp',
    'Recording.MusicOff': 'Nhạc đang tắt',
    'Recording.MusicOn': 'Nhạc đang bật',
    'Recording.MusicStatusArchetype': 'Nhạc nền đang phát cho {Archetype} ở cường độ {Intensity}.',
    'Recording.MusicStatusMood': 'Nhạc nền đang phát cho tâm trạng {Mood} ở cường độ {Intensity}.',
    'Recording.MusicStatusMuted': 'Nhạc nền đã tắt tiếng.',
    'Recording.MusicStatusPaused': 'Nhạc nền đã tạm dừng.',
    'Recording.MusicVolume': 'Âm lượng nhạc nền',
    'Recording.PacerAria': 'Nhịp đọc kịch bản — máy đếm nhịp chạy theo độ dài bài tập',
    'Recording.PacerOff': 'Nhịp đọc đang tắt',
    'Recording.PacerOn': 'Nhịp đọc đang bật',
    'Recording.PacerUnavailable': 'Không có nhịp đọc',
    'Recording.PacerUnavailableAria': 'Không có nhịp đọc kịch bản — kịch bản dự phòng này không được canh theo độ dài bản thu của bạn, nên không có nhịp để chạy',
    'Recording.RecordAgain': 'Ghi lại',
    'Recording.RecoveryIllustrationAria': 'Thanh địa chỉ trình duyệt với biểu tượng thông tin trang (i) được làm nổi bật',
    'Recording.RecoverySteps': 'Để cấp lại quyền, hãy nhấp vào biểu tượng thông tin trang **(i)** bên cạnh thanh địa chỉ của trình duyệt và cho phép camera & micro, rồi thử lại.',
    'Recording.RerecordCancel': 'Hủy',
    'Recording.RerecordConfirm': 'Xóa và ghi lại',
    'Recording.RerecordConfirmTitle': 'Bạn có chắc muốn ghi lại không. Việc này sẽ xóa bản thu hiện tại của bạn.',
    'Recording.StatusStartingCamera': 'Đang khởi động camera…',
    'Recording.TryAgain': 'Thử lại',
    'RecordingElsewhere.Body': 'Bạn đang ghi âm {Practice} ở tab hoặc cửa sổ khác. Vui lòng quay lại đó để hoàn thành bản thu.',
    'RecordingElsewhere.CloseBlockedAck': 'Đã hiểu',
    'RecordingElsewhere.CloseBlockedHint': 'Trình duyệt không thể tự đóng tab này — nhấn {Shortcut} để đóng.',
    'RecordingElsewhere.DismissAria': 'Đóng',
    'RecordingElsewhere.Heading': 'Bạn đang ghi âm ở tab khác',
    'RecordingElsewhere.Ok': 'Đóng tab này',
    'RecordingElsewhere.OkAria': 'Đóng tab này',
    'RecordingElsewhere.PracticeFallback': 'một bài luyện tập',
    'RecordingElsewhere.StopStartAria': 'Dừng bản thu đó và tiếp tục ở đây',
    'RecordingElsewhere.StopStartIdle': 'Dừng bản thu đó và tiếp tục ở đây',
    'RecordingElsewhere.StopStartStopping': 'Đang dừng…',
    'RecordingSettings.AutoDeleteHint': 'Xóa các bản thu đã lưu vào tài khoản sau số ngày bạn chọn. Bản thu chỉ giữ trên thiết bị này sẽ tự xóa sau {Days} ngày.',
    'RecordingSettings.AutoDeleteLabel': 'Tự động xóa bản thu cũ',
    'RecordingSettings.AutoSaveHint': 'Tự động lưu mọi bản thu đã hoàn tất vào thư viện của bạn (tốn dung lượng). Bật sẵn cho gói Cao cấp — hãy tắt đi để giữ các bản thu trên thiết bị này cho đến khi bạn tự lưu.',
    'RecordingSettings.AutoSaveLabel': 'Tự động lưu bản thu',
    'RecordingSettings.CueLengthHint': 'Hiệu ứng của gợi ý ở trên kịch bản trong bao lâu, để bạn kịp làm theo. Lời gợi ý dài hơn luôn có đủ thời gian của nó.',
    'RecordingSettings.CueLengthLabel': 'Độ dài gợi ý',
    'RecordingSettings.CueLengthLong': 'Dài · {Seconds} giây',
    'RecordingSettings.CueLengthNormal': 'Vừa · {Seconds} giây',
    'RecordingSettings.CueLengthShort': 'Ngắn · {Seconds} giây',
    'RecordingSettings.DefaultQualityHint': 'Các bản thu mới bắt đầu ở chất lượng này. Chất lượng cao hơn tốn nhiều dung lượng hơn. Bạn vẫn có thể đổi trước mỗi bản thu.',
    'RecordingSettings.DefaultQualityLabel': 'Chất lượng ghi mặc định',
    'RecordingSettings.Heading': 'Cài đặt ghi âm',
    'RecordingSettings.KeepDaysAria': 'Số ngày giữ bản thu đã lưu',
    'RecordingSettings.KeepDaysLabel': 'Giữ bản thu đã lưu trong',
    'RecordingSettings.KeepDaysOutOfRange': 'Bản thu đã lưu có thể được giữ từ {Min} đến {Max} ngày. Giá trị này sẽ về {Settled}.',
    'RecordingSettings.KeepDaysUnit': 'ngày',
    'RecordingSettings.Lede': 'Kiểm soát việc các bản thu của bạn có được lưu lên đám mây hay không, và chất lượng ghi của các bản thu mới.',
    'RecordingSettings.LedeWithoutStorage': 'Chọn chất lượng ghi của các bản thu mới và tốc độ nói ưa thích của bạn.',
    'RecordingSettings.PracticeRemindersHint': 'Nếu kế hoạch 12 tuần của bạn bị chậm và bạn tạm ngừng luyện, chúng tôi gửi email nhắc tối đa một lần mỗi tuần. Lời nhắc dừng lại sau hai lần không được phản hồi, cho đến khi bạn luyện tập lại.',
    'RecordingSettings.PracticeRemindersLabel': 'Lời nhắc luyện tập',
    'RecordingSettings.Save': 'Lưu cài đặt',
    'RecordingSettings.Saved': 'Đã lưu cài đặt ghi âm.',
    'RecordingSettings.Saving': 'Đang lưu…',
    'RecordingSettings.SectionAria': 'Cài đặt ghi âm',
    'RecordingSetup.BlurDisabledByPick': 'Làm mờ chỉ hỗ trợ tối đa {Cap}, nên đã tắt cho độ phân giải này.',
    'RecordingSetup.BlurLimitsQuality': 'Làm mờ đang bật — bản thu bị giới hạn ở {Cap}.',
    'RecordingSetup.BlurOff': 'Làm mờ: tắt',
    'RecordingSetup.BlurOn': 'Làm mờ: bật',
    'RecordingSetup.BlurUnavailable': 'Hiện không thể làm mờ nền, nên lượt thu này đang ghi mà không làm mờ.',
    'RecordingSetup.Camera': 'Camera',
    'RecordingSetup.CameraFallback': 'Camera {Index}',
    'RecordingSetup.Microphone': 'Micro',
    'RecordingSetup.MicrophoneFallback': 'Micro {Index}',
    'RecordingSetup.NoiseReductionLocked': 'Không đổi được khử tiếng ồn nền trong khi đang ghi.',
    'RecordingSetup.NoiseReductionOff': 'Khử tiếng ồn: tắt',
    'RecordingSetup.NoiseReductionOffNotice': 'Khử tiếng ồn đang tắt — nhạc nền, gợi ý bằng giọng nói và tiếng ồn trong phòng có thể lọt vào bản thu.',
    'RecordingSetup.NoiseReductionOn': 'Khử tiếng ồn: bật',
    'RecordingSetup.PermissionDenied': 'Quyền truy cập camera và micro đang tắt, nên không thể chọn thiết bị. Hãy cho phép truy cập trong trình duyệt để chọn camera hoặc micro và xem trước.',
    'RecordingSetup.PreviewFailed': 'Không thể khởi động xem trước camera.',
    'RecordingSetup.VideoQualityCycleAria': 'Chất lượng video {Current}. Chọn để đổi sang {Next}.',
    'RecordingSetup.VideoQualityLocked': 'Không đổi được chất lượng video trong khi đang ghi.',
    'ReviewPack.Download': 'Tải gói đánh giá',
    'ReviewPack.ErrorForbidden': 'Bạn không có quyền truy cập bản thu này.',
    'ReviewPack.ErrorGeneric': 'Tải xuống thất bại. Vui lòng thử lại.',
    'ReviewPack.ErrorGone': 'Bản thu này không còn khả dụng để tải xuống.',
    'ReviewPack.ErrorPending': 'Đánh giá chưa sẵn sàng — vui lòng thử lại sau giây lát.',
    'ReviewPack.ErrorSignIn': 'Vui lòng đăng nhập và thử lại.',
    'ReviewPack.ErrorUnavailable': 'Dịch vụ tải xuống tạm thời không khả dụng. Vui lòng thử lại.',
    'ReviewPack.Pending': 'Đánh giá chưa sẵn sàng',
    'ReviewPack.PreparingPack': 'Đang chuẩn bị gói đánh giá của bạn…',
    'ReviewPack.Saved': 'Đã lưu vào thư mục Tải xuống của bạn.',
    'SaveToLibrary.AddStorage': 'Thêm dung lượng',
    'SaveToLibrary.AutoUploadFailed': 'Tự động tải lên thất bại — bản thu này vẫn nằm trên thiết bị của bạn.',
    'SaveToLibrary.BackgroundSaved': 'Đã lưu bản thu',
    'SaveToLibrary.BackgroundSaving': 'Đang lưu bản thu…',
    'SaveToLibrary.BackgroundSavingPercent': 'Đang lưu bản thu… {Percent}%',
    'SaveToLibrary.DismissAria': 'Đóng',
    'SaveToLibrary.Failed': 'Không lưu được bản thu này. Vui lòng thử lại.',
    'SaveToLibrary.Heading': 'Giữ lại bản thu này',
    'SaveToLibrary.ManageStorage': 'Quản lý dung lượng',
    'SaveToLibrary.NotAvailable': 'Gói hiện tại của bạn không hỗ trợ lưu vào thư viện.',
    'SaveToLibrary.Nudge': 'Hãy lưu các bản thu để giữ lại chúng',
    'SaveToLibrary.OutOfStorage': 'Bạn đã hết dung lượng, nên bản thu này vẫn nằm trên thiết bị của bạn — chỉ được giữ ở đây {Days} ngày, sau đó sẽ mất. Hãy thêm dung lượng hoặc dọn bớt vài bản thu, rồi lưu lại.',
    'SaveToLibrary.OverLimit': 'Bạn đã vượt quá dung lượng lưu trữ — hãy thêm dung lượng, hoặc dọn bớt vài bản thu.',
    'SaveToLibrary.PrePracticeWarning': 'Bạn đã hết dung lượng. Nếu vẫn luyện tập thì bản thu này sẽ không được lưu vào thư viện hay giữ cho tuần làm chủ của bạn, và lưu thủ công cũng sẽ bị từ chối — bài luyện thì vẫn được tính. Bản thu chỉ nằm trên thiết bị này {Days} ngày.',
    'SaveToLibrary.PrePracticeWarningManual': 'Bạn đã hết dung lượng. Nếu vẫn luyện tập thì việc lưu bản thu này vào thư viện sẽ bị từ chối — bài luyện thì vẫn được tính. Bản thu chỉ nằm trên thiết bị này {Days} ngày.',
    'SaveToLibrary.Retry': 'Thử lại',
    'SaveToLibrary.Save': 'Lưu vào thư viện của tôi',
    'SaveToLibrary.Saving': 'Đang lưu…',
    'SaveToLibrary.ShowInLibraryAria': '{Status} — xem lượt này trong Thư viện của tôi',
    'SaveToLibrary.UploadingAria': 'Đang lưu bản thu này vào thư viện của bạn',
    'SaveToLibrary.UpsellSave': 'Lưu vào Thư viện 🔒',
    'Search.Clear': 'Xóa tìm kiếm',
    'Search.Label': 'Tìm trong danh sách này',
    'Search.NoMatch': 'Không có gì khớp với “{Query}”.',
    'Search.NoMatchFiltered': 'Không có gì khớp với “{Query}” khi các bộ lọc đang bật.',
    'Search.Placeholder': 'Nhập để lọc…',
    'Search.ResultsMany': '{Count} kết quả',
    'Search.ResultsOne': '{Count} kết quả',
    'SelfReview.Auditory': 'Kiểm tra âm thanh',
    'SelfReview.AuditoryShort': 'Âm thanh',
    'SelfReview.CheckDoneAria': '{Check}: đã xong',
    'SelfReview.CheckNotDoneAria': '{Check}: chưa xong',
    'SelfReview.ChecksAria': 'Các lượt tự đánh giá',
    'SelfReview.Done': 'Xong',
    'SelfReview.ModesAria': 'Chế độ phát',
    'SelfReview.NormalPlayback': 'Phát bình thường',
    'SelfReview.Saving': 'Đang lưu lượt kiểm tra',
    'SelfReview.Transcript': 'Kiểm tra bản ghi lời',
    'SelfReview.TranscriptShort': 'Bản ghi lời',
    'SelfReview.Visual': 'Kiểm tra hình ảnh',
    'SelfReview.VisualShort': 'Hình ảnh',
    'SessionDetail.Back': 'Quay lại',
    'SessionDetail.BackAria': 'Quay lại trang trước',
    'SessionDetail.FailedToLoad': 'Không tải được phiên.',
    'SessionDetail.SessionNotFound': 'Không tìm thấy phiên.',
    'SessionDetail.TabDefault': 'Phiên luyện tập · VoiceDojo',
    'SessionDetail.TabRecording': '{Name} · Đang ghi · VoiceDojo',
    'SessionDetail.Untitled': 'Chưa đặt tên',
    'SessionPanel.AwaitingHint': 'Đã xác nhận cài đặt — đang chuẩn bị phiên của bạn…',
    'SessionPanel.CannotEnd': 'Không thể kết thúc phiên ({Status}).',
    'SessionPanel.ConfirmEnd': 'Kết thúc phiên sớm?',
    'SessionPanel.ConfirmLeave': 'Bạn đang ghi âm — rời đi và dừng lần thu?',
    'SessionPanel.DurationLabel': 'Thời lượng',
    'SessionPanel.EndSession': 'Kết thúc phiên',
    'SessionPanel.EndSessionAria': 'Kết thúc phiên',
    'SessionPanel.EndSessionEnding': 'Đang kết thúc…',
    'SessionPanel.NetworkError': 'Lỗi mạng. Vui lòng thử lại.',
    'SessionPanel.NewSession': 'Phiên mới',
    'SessionPanel.PersonaliseAriaLabel': 'Cá nhân hóa gợi ý huấn luyện',
    'SessionPanel.PersonaliseFieldLabel': 'Mục tiêu của bài luyện này là gì?',
    'SessionPanel.PersonaliseLabel': 'Cá nhân hóa (tùy chọn)',
    'SessionPanel.PersonalisePlaceholder': 'ví dụ: thuyết trình cho nhà đầu tư',
    'SessionPanel.QuotaExhaustedGuest': 'Đã đạt giới hạn luyện tập hàng ngày.',
    'SessionPanel.QuotaExhaustedLimit': 'Đã đạt giới hạn luyện tập hàng ngày — thử lại vào ngày mai.',
    'SessionPanel.QuotaRemaining': 'Còn {Remaining} trong số {Limit} {Sessions} luyện tập hôm nay.',
    'SessionPanel.QuotaRemainingManySessions': 'phiên',
    'SessionPanel.QuotaRemainingOneSession': 'phiên',
    'SessionPanel.ResumeSession': 'Tiếp tục phiên',
    'SessionPanel.ResumeSessionAria': 'Tiếp tục phiên',
    'SessionPanel.SessionDurationAria': 'Thời lượng phiên (phút)',
    'SessionPanel.StartNewSessionAria': 'Bắt đầu phiên mới',
    'SessionPanel.StartSession': 'Bắt đầu phiên',
    'SessionPanel.StartSessionAria': 'Bắt đầu phiên',
    'SessionPanel.StartSessionStarting': 'Đang bắt đầu…',
    'SessionPanel.StillLoading': 'Vẫn đang tải — vui lòng thử lại sau một lúc.',
    'SessionPanel.TimeElapsed': 'Thời gian đã trôi qua: {Time}',
    'SessionPanel.TimerAria': 'Thời gian còn lại',
    'SignUpCta.GuestClaimReason': 'Hãy tạo tài khoản để lưu tiến bộ của bạn — phần luyện tập sẽ được mang theo. Đăng ký nhanh gọn, không cần mật khẩu.',
    'SignUpCta.GuestPracticeReason': 'Bài luyện này cần tài khoản. Hãy tạo tài khoản để mở khóa — đăng ký nhanh gọn, không cần mật khẩu.',
    'SignUpCta.GuestPrimary': 'Lưu tiến độ của bạn',
    'SignUpCta.GuestReason': 'Tạo tài khoản để mở khóa Đánh giá AI cho bản thu này — và lưu tiến độ của bạn. Các phiên và bài luyện của bạn sẽ được chuyển sang.',
    'SignUpCta.GuestSecondary': 'Đã từng dùng trước đây?',
    'SignUpCta.GuestUploadReason': 'Bạn cần tài khoản để tải bản thu lên cho Đánh giá AI. Hãy tạo tài khoản để bắt đầu — đăng ký nhanh gọn, không cần mật khẩu.',
    'SignUpCta.NeedAccountPrimary': 'Đăng ký nhận {SignupBonus} tín dụng miễn phí',
    'SignUpCta.NeedAccountReason': 'Muốn đánh giá AI cho bản thu của bạn? Bạn cần tài khoản + tín dụng — đăng ký mới nhận {SignupBonus} tín dụng miễn phí.',
    'SignUpCta.NeedAccountSecondary': 'Xem bảng giá',
    'SignUpCta.OutOfCreditsPrimary': 'Thêm tín dụng',
    'SignUpCta.OutOfCreditsReason': 'Bạn đã hết tín dụng. Mua gói tín dụng hoặc đăng ký Cao cấp để tiếp tục luyện tập với Đánh giá AI.',
    'SignUpCta.OutOfCreditsSecondary': 'Xem hóa đơn',
    'SignUpCta.PremiumPlansReason': 'Lịch sử kế hoạch thuộc về Tiến trình, một tính năng Cao cấp — mọi kế hoạch 12 tuần bạn đã chạy, kèm số tuần bạn hoàn thành. Hãy nâng cấp để mở khóa.',
    'SignUpCta.PremiumPracticePrimary': 'Nâng cấp lên Cao cấp',
    'SignUpCta.PremiumProgressReason': 'Tiến trình là tính năng Cao cấp — kế hoạch thành thạo 12 tuần theo dõi số lần luyện tập từng tuần và lưu lại bản thu mỗi tuần để xem lại. Hãy nâng cấp để mở khóa.',
    'SignUpCta.PremiumRehearsalReason': 'Thuyết trình bài nói của bạn trực tiếp trước một nhà đầu tư, khách hàng hoặc hội đồng AI. Họ ngắt lời, phản biện, rồi nhận xét bằng lời. Tập dượt thuộc gói Cao cấp.',
    'SignUpCta.PreviewAria': 'Ví dụ về tính năng Cao cấp',
    'SignUpCta.PreviewBadge': 'Dữ liệu ví dụ',
    'SignUpCta.PreviewNote': 'Bảng phía sau thẻ này là ví dụ về những gì bản Cao cấp hiển thị — không phải số liệu của bạn.',
    'SignUpCta.SectionAria': 'Cần tài khoản để tiếp tục',
    'StandaloneUpload.ChooseDifferent': 'Chọn tệp khác',
    'StandaloneUpload.ErrorContentType': 'Hãy chọn bản thu .mov, .mp4 hoặc .webm.',
    'StandaloneUpload.ErrorSignIn': 'Vui lòng đăng nhập để đánh giá một bản thu.',
    'StandaloneUpload.ErrorSize': 'Bản thu phải từ 1 byte đến {MaxSize}.',
    'StandaloneUpload.Reviewing': 'Đang đánh giá **{Name}**.',
    'StandaloneUpload.UploadRecording': 'Tải bản thu lên',
    'StatusPill.PendingReview': 'Chờ đánh giá',
    'StatusPill.Recording': 'Đang ghi',
    'StatusPill.ReviewFailed': 'Đánh giá thất bại',
    'StatusPill.Reviewed': 'Đã đánh giá',
    'StatusPill.Status': 'Trạng thái',
    'Streaming.GenerationFailed': 'Tạo nội dung thất bại. Vui lòng thử lại.',
    'Streaming.Preparing': 'Đang chuẩn bị…',
    'Streaming.PreparingCues': 'đang chuẩn bị gợi ý…',
    'Streaming.TryAgain': 'Thử lại',
    'Streaming.YourWord': 'Từ của bạn',
    'Support.CouldNotVerify': 'Chúng tôi không thể xác minh yêu cầu này do một người gửi. Nếu bạn đang bật trình chặn nội dung, hãy cho phép Google reCAPTCHA trên trang này rồi thử lại, hoặc gửi email cho chúng tôi tại [{Email}](mailto:{Email}).',
    'Support.DescriptionLabel': 'Chuyện gì đã xảy ra?',
    'Support.EmailLabel': 'Email của bạn',
    'Support.Failed': 'Yêu cầu của bạn chưa được gửi. Vui lòng thử lại, hoặc gửi email cho chúng tôi tại [{Email}](mailto:{Email}).',
    'Support.FormAria': 'Biểu mẫu yêu cầu hỗ trợ',
    'Support.Heading': 'Hỗ trợ',
    'Support.Intro': 'Gặp khó khăn, phát hiện lỗi hay có ý tưởng? Hãy cho chúng tôi biết bên dưới hoặc viết thư tới [{Email}](mailto:{Email}).',
    'Support.NameLabel': 'Tên của bạn',
    'Support.RateLimited': 'Bạn đã gửi nhiều yêu cầu trong thời gian ngắn. Vui lòng thử lại sau, hoặc gửi email cho chúng tôi tại [{Email}](mailto:{Email}).',
    'Support.RecaptchaNotice': 'Trang này được bảo vệ bởi reCAPTCHA, và [Chính sách quyền riêng tư](https://policies.google.com/privacy) cùng [Điều khoản dịch vụ](https://policies.google.com/terms) của Google được áp dụng.',
    'Support.Sent': 'Chúng tôi đã nhận được yêu cầu. Email xác nhận kèm mã yêu cầu đang được gửi tới {Email}, và chúng tôi sẽ trả lời qua email.',
    'Support.Submit': 'Gửi yêu cầu',
    'Support.Submitting': 'Đang gửi…',
    'Support.SummaryLabel': 'Tóm tắt',
    'Support.Title': 'Hỗ trợ · VoiceDojo',
    'Theme.DarkTheme': 'Giao diện tối',
    'Theme.LightTheme': 'Giao diện sáng',
    'Theme.SwitchToDark': 'Chuyển sang giao diện tối',
    'Theme.SwitchToLight': 'Chuyển sang giao diện sáng',
    'Thinking.Articulating': 'Phát âm rõ từng chữ…',
    'Thinking.ClearingThroat': 'Hắng giọng…',
    'Thinking.DeepBreath': 'Hít thở thật sâu…',
    'Thinking.FindingPitch': 'Dò cao độ…',
    'Thinking.FindingVoice': 'Tìm lại giọng nói…',
    'Thinking.Humming': 'Ngân nga một nốt…',
    'Thinking.Legato': 'Luyến láy mượt mà…',
    'Thinking.LooseningJaw': 'Thả lỏng hàm…',
    'Thinking.LowerRegister': 'Hạ xuống âm vực trầm…',
    'Thinking.MarkingScript': 'Đánh dấu kịch bản…',
    'Thinking.Mirror': 'Tập trước gương…',
    'Thinking.Pacing': 'Tìm nhịp nói…',
    'Thinking.Pausing': 'Ngừng lại tạo điểm nhấn…',
    'Thinking.PowerSphere': 'Tìm Power Sphere…',
    'Thinking.Projecting': 'Vang tới hàng ghế cuối…',
    'Thinking.Siren': 'Luyện siren…',
    'Thinking.Staccato': 'Ngắt nhịp dứt khoát…',
    'Thinking.TongueTwisters': 'Luyện câu líu lưỡi…',
    'Thinking.WarmWater': 'Nhấp ngụm nước ấm…',
    'Thinking.WarmingUp': 'Khởi động giọng…',
    'Toast.DismissAria': 'Đóng thông báo',
    'Toast.LiveUpdatesBack': 'Cập nhật trực tiếp đã hoạt động trở lại.',
    'Toast.LiveUpdatesPaused': 'Cập nhật trực tiếp đang tạm dừng. Trang vẫn hoạt động; hãy tải lại để xem nội dung mới nhất.',
    'Toast.RegionAria': 'Thông báo',
    'Transport.Elapsed': 'Đã trôi qua {Time}',
    'Transport.Pause': 'tạm dừng',
    'Transport.StatusRecording': 'đang ghi',
    'Transport.Stop': 'dừng',
    'UnsubscribeReminders.Confirm': 'Tắt lời nhắc',
    'UnsubscribeReminders.Done': 'Đã tắt lời nhắc luyện tập. Bạn có thể bật lại trong hồ sơ của mình.',
    'UnsubscribeReminders.Heading': 'Tắt lời nhắc luyện tập?',
    'UnsubscribeReminders.Lede': 'Chúng tôi sẽ ngừng gửi email khi kế hoạch 12 tuần của bạn bị chậm. Bạn có thể bật lại trong hồ sơ của mình.',
    'UnsubscribeReminders.MissingLink': 'Liên kết hủy đăng ký này không đầy đủ. Hãy dùng liên kết trong email, hoặc tắt lời nhắc trong hồ sơ của bạn.',
    'UnsubscribeReminders.Title': 'Lời nhắc luyện tập · VoiceDojo',
    'UnsubscribeReminders.Working': 'Đang tắt…',
  },
} as const;

